//大小寫需一致
const zh_TW = {
  "TitleName": "健康檢查報告",
  "PleaseEnterID": "請輸入您的身分證號",
  "DeleteReport": "刪除報告",
  'PleaseSelectOne': '請選擇一筆',
  "手機": "手機",
  "狀態": "狀態",
  "夾圖": "夾圖",
  "報到日": "報到日",
  "健檢日": "健檢日",
  "寄": "寄",
  "ID.": "身分證字號",
  "Name": "姓名",
  'Gender': '性別',
  'Birth': '生日',
  'Date': '體檢日期',
  'No.': '體檢編號',
  'Age': '年齡',
  'Personalinfo': '個人資訊',
  'BirthDate': '出生年月日',
  'ExamDate': '體檢日期',
  'ExamNo': '體檢編號',
  'AssessmentInfo': '問診資訊',
  'BasicAssessment': '基本資料',
  'Item': '項目',
  'Value': '報告值',
  'Ref.': '參考值',
  'Suggestion': '建議',
  'AbnormalitySuggestions': '異常清單&建議事項',
  'Physique': '一般體格',
  'DoctorConsultation': '醫生問診',
  'Result': '判讀結果',
  '男': '男',
  '女': '女',
  '(60～100 次/分)':'(60～100 次/分)',
 

  
  //主項目的說明
  "0601": "肺功能檢查是最方便、快速、安全又無侵襲性的檢查，可了解是否有呼吸道阻塞情形，肺活量有無異常，肺泡與微血管氣體交換的能力等，能協助醫師診斷及鑑別疾病、評估肺部疾病的嚴重度、評估病程進展及治療後的反應。",
  "0602": "子宮頸抹片(Pap smear)是由醫師將擴張器放入陰道，取子宮頸及陰道後穹窿分泌物，塗在玻片上，以 95％酒精固定送至病理科，在顯微鏡下檢查。子宮頸抹片檢查是採取子宮頸及陰道後壁的剝落細胞所做的檢查。這個檢查能夠顯示出子宮頸有無感染、發炎、異常細胞或是癌症發生之可能。",
  7091: "骨質疏鬆症是世界衛生組織認定的全球重要疾病，骨鬆可能造成骨折進而影響生活自理能力與生活品質，積極的骨鬆防治可以降低骨折風險。本院採用中軸型雙能量X光吸收儀（DXA）為骨質密度檢測之黃金標準。利用雙能量X光吸收儀（DXA）掃描身體骨質較易流失的中軸部位骨頭，也是最易發生骨鬆性骨折的腰椎或髖關節之骨質密度。",
  7060: "人體的體重由四大要素組成，身體總水重、蛋白質、礦物質、體脂肪。各成分間需維持一定的比率，以確保健康，反之，則可能產生各種病癥，如：脂肪過多而肥胖、蛋白質不足而營養不良、身體總水量過低、細胞內水份流失會導致老化、礦物質流失可能骨質疏鬆。理想體脂率正常範圍：男性14-25%、女性20-30%，其餘項目之數值，請參考附圖。",
  7008: "心臟疾病診斷及治療中最基本檢查之一，它除了可能表現心臟結構功能異常，優於聽診器辨別心跳，可以檢測出心律不整、心房心室肥厚或心肌缺氧、狹心症、肺動脈栓塞，甚至心肌梗塞。",
  7042: "心率變異分析（縮寫為HRV），是一種量測連續心跳速率變化程度的方法。因為心臟除了本身的節律性放 電引發的跳動之外，也受到自律神經系統的影響。調節我們的心率、血壓、呼吸和消化，它被分為兩大部分：交感神經和副交感神經系統，所以HRV目前除了被廣泛運用在心臟相關的疾病醫療上，也同時是檢視自律神經系統的重要指標。",
  7041: "藉由紅外線直接檢測手指末梢微血管循環與彈性狀況，測量其血液循環時速率變異，分析檢測波形再 轉換成數據，將血管彈性分為七等級，進而評估血管彈性、老化、心臟血管、腦部血管、周邊血管之疾病風險。",
  7023: "眼底檢查可以看到視網膜的色澤、視網膜的血管、黃斑部的顏色、以及視神經乳頭的形狀、顏色、乳頭凹陷的情形。最重要的意義是檢測出眼底(視網膜、脈絡膜、視神經乳頭)是否有病變，如:視網膜剝離、黃斑部病變、青光眼、視神經炎、脈絡膜腫瘤等。眼睛是全身唯一可以透過肉眼就觀察到血管的地方，因此，在臨床上有許多案例是在眼底檢查中才發現患者還有全身性的疾病，像是高血壓、糖尿病、自體免疫疾病等。",
  7029: "利用內視鏡檢查病人的結腸內可能的病兆(如潰瘍性結 腸炎、出血源、瘜肉、阻塞等情形)，可評估病灶的外表性徵，必要時，醫師能夠在觀察的同時施行組織切片分析，以進一步檢查。確定安排檢查後，醫護人員會向您解釋治療目的、過程及應配合事項後，安排檢查時間，並由病人或家屬簽署檢查治療同意書。",
  7030: "胃鏡除了胃部，還能夠察看是否有食道癌、胃潰瘍、十二指腸潰瘍、逆流性食道炎等。",
  7034: "X光檢查是一種簡單快速可以初步判斷受檢部位是否有明顯異常的檢查項目，以偵測是否攝入異物、腎結石，腰椎側彎，關節退化，骨刺形成或骨折等異常。",
  7052: "X光管球以弧形移動拍照，可藉由一次性攝影取得同部位不同深度的多張影像，提供醫師更多影像資訊做診斷。",
  7054: "X光管球以不同的角度旋轉拍攝二至四張影像並自動合成，分為全脊椎攝影及下肢攝影。全脊椎攝影可檢查頸椎、胸椎及腰椎是否有側彎、骨刺等。下肢攝影可檢查長短腳、骨盆左右傾斜等。",
  7033: "X光檢查是一種簡單快速可以初步判斷受檢部位是否有明顯異常的檢查項目，以胸腔X光為例，如肺炎、肺結核、肺氣腫、肺積水、氣胸等肺部病變，常可見其典型的影像呈現，是一種迅速又無痛的檢查方式。其他常見應用於診斷脊椎側彎、骨刺、鈣化、結石等。",
  7014: "可檢查甲狀腺是否有病變，如：腫大、結節或鈣化等。",
  7011: "可檢查攝護腺及膀胱是否有病變，如：囊腫、鈣化、良性攝護腺肥大等。",
  7010: "可檢查肝臟、膽囊、胰臟、脾臟、腎臟等器官是否有病變，如：脂肪肝、囊腫、血管瘤、瘜肉、膽結石或腎臟結石或腫塊等。超音波僅能簡單初步篩檢，依照部位不同，可能因未能配合吸吐氣，腸氣過多及未脹尿或個人因素致難以完整檢查，務必配合相關症狀及抽血數據綜合考量。",
  7049: "胸部雙能量減影透過高低能量之X光技術，將骨頭及軟組織分離，避免病灶被遮蔽，較容易判斷肺部病灶位置。",
  7012: "可檢查乳房是否有病變，如：纖維囊腫、腺瘤、腫瘤或腋下淋巴結腫大等。",
  7013: "骨盆腔超音波稱婦科超音波，可檢查子宮、卵巢等器官是否有病變，如：囊腫、子宮肌瘤、子宮內膜增厚、腫塊等。",
  7015: "可檢查頸總動脈及內頸動脈、外頸動脈血管內部是否有病變，如：鈣化、斑塊或動脈內膜-中層厚度(IMT)增厚等。",
  7016: "可觀察心臟腔室的大小、心室的收縮與舒張功能、心肌有無受損、瓣膜異常的種類及嚴重程度、肺高壓、腔室內血流的異常與心包膜疾病。 適應症:\n1.心雜音\n2.瓣膜狹窄與逆流\n3.心包膜疾病\n4.冠狀動脈疾病\n5.心臟腫塊\n6.肺高壓。",
  7021: "骨質疏鬆症是世界衛生組織認定的全球重要疾病，骨鬆可能造成骨折進而影響生活自理能力與生活品質，積極的骨鬆防治可以降低骨折風險。本院採用中軸型雙能量X光吸收儀（DXA）為骨質密度檢測之黃金標準。利用雙能量X光吸收儀（DXA）掃描身體骨質較易流失的中軸部位骨頭，也是最易發生骨鬆性骨折的腰椎或髖關節之骨質密度。",
  7162: "RMSSD心臟負荷指數:正常應大於20，若小於20表示副交感對心臟調控度變差,注意勞累,壓力,抽菸等易造成心臟負荷變大。",
  7043: "LF／HF自律神經平衡訊息：正常應介於0.5-2.0之間，若小於0.5,可能有情緒低落現象；若大於2.0,可能有亢進,焦慮,急躁現象。",
  7044: "PSI壓力指數：正常應小於50，若大於50表示可能長期處於壓力負擔之下。",
  7070: "",
  7076: "",
  7055: "",
  "自覺症狀": "自覺症狀",
  "既往病史": "既往病史",
  "生活習慣": "生活習慣",
  "Content": "內容",
  "System Overview": "System Overview",
  "System Overview Description": "以器官系統性的分類，顯示異常項目的數量與嚴重度，以幫助您對自已的身體健康狀態，有完整的了解。",
  "Abnormality Description": "總評醫師綜合所有檢驗數據及影像檢查結果，為您詳細列出本次健檢所發現的異常項目，提供完整的異常清單及建議事項。",
  //items
  "其他檢查": "其他檢查",
  "影像檢查": "影像檢查",
  "理學檢查": "理學檢查",
  "基本資料": "基本資料",
  "異常項目": "異常項目",
  "檢驗": "檢驗",


  //subitems
  "一般體格": "一般體格",
  "醫生問診": "醫生問診",
  "尿液常規檢查": "尿液常規檢查",
  "尿沉渣": "尿沉渣",
  "血液檢查": "血液檢查",
  "生化檢查": "生化檢查",
  "腫瘤標記": "腫瘤標記",
  "甲狀腺檢查": "甲狀腺檢查",
  "血清免疫檢查": "血清免疫檢查",
  "賀爾蒙檢查": "賀爾蒙檢查",
  "基因檢查": "基因檢查",
  "功能醫學": "功能醫學",
  "肝炎檢查": "肝炎檢查",
  "糞便檢查": "糞便檢查",
  "重金屬檢查": "重金屬檢查",
  "微生物檢查": "微生物檢查",
  "肺功能檢查": "肺功能檢查",
  "抹片檢查": "抹片檢查",
  "分泌物檢查": "分泌物檢查",
  "超音波檢查": "超音波檢查",
  "胸部能量減影": "胸部能量減影",
  "一般X光": "一般X光",
  "三連片": "三連片",
  "內視鏡": "內視鏡",
  "身體組成分析": "身體組成分析",
  "心電圖": "心電圖",
  "自律神經檢查": "自律神經檢查",
  "眼底攝影": "眼底攝影",
  "數位斷層合成掃描": "數位斷層合成掃描",
  "DXA 正面脊椎": "DXA 正面脊椎",

  //overview
  "神經系統": "神經系統",
  "頭頸部與心血管系統": "頭頸部與心血管系統",
  "血液": "血液",
  "胸腔與呼吸系統": "胸腔與呼吸系統",
  "免疫系統": "免疫系統",
  "腹部與肝膽腸胃系統": "腹部與肝膽腸胃系統",
  "泌尿生殖系統": "泌尿生殖系統",
  "肌肉骨骼系統": "肌肉骨骼系統",
  "新陳代謝": "新陳代謝",
  "abnormality": "項異常",
  "":"",
  "undefined":"undefined",
  "null":"null",
  //Ary02
  "備註": "備註",
  "飯前血糖": "飯前血糖",
  "條碼號": "條碼號",
  "專案名稱": "專案名稱",
  "身高": "身高",
  "體重": "體重",
  "收縮壓": "收縮壓",
  "舒張壓": "舒張壓",
  "裸視(右眼)": "裸視(右眼)",
  "裸視(左眼)": "裸視(左眼)",
  "矯正視力(右眼)": "矯正視力(右眼)",
  "矯正視力(左眼)": "矯正視力(左眼)",
  "辨色力": "辨色力",
  "聽力(右耳)": "聽力(右耳)",
  "聽力(左耳)": "聽力(左耳)",
  "身體質量指數(BMI)": "身體質量指數(BMI)",
  "腰圍": "腰圍",
  "脈搏": "脈搏",
  "問診(自覺症狀及睡眠概況等)": "問診(自覺症狀及睡眠概況等)",
  "嗜酸性白血球計算": "嗜酸性白血球計算",
  "抗穆勒氏管荷爾蒙(AMH)": "抗穆勒氏管荷爾蒙(AMH)",
  "抗精蟲抗體": "抗精蟲抗體",
  "頭頸部": "頭頸部",
  "呼吸系統": "呼吸系統",
  "心臟血管系統": "心臟血管系統",
  "消化系統": "消化系統",
  "皮膚系統": "皮膚系統",
  "聽力500HZ(左)": "聽力500HZ(左)",
  "聽力1000HZ(左)": "聽力1000HZ(左)",
  "聽力2000HZ(左)": "聽力2000HZ(左)",
  "聽力3000HZ(左)": "聽力3000HZ(左)",
  "聽力4000HZ(左)": "聽力4000HZ(左)",
  "聽力6000HZ(左)": "聽力6000HZ(左)",
  "聽力8000HZ(左)": "聽力8000HZ(左)",
  "聽力500HZ(右)": "聽力500HZ(右)",
  "聽力1000HZ(右)": "聽力1000HZ(右)",
  "聽力2000HZ(右)": "聽力2000HZ(右)",
  "聽力3000HZ(右)": "聽力3000HZ(右)",
  "聽力4000HZ(右)": "聽力4000HZ(右)",
  "聽力6000HZ(右)": "聽力6000HZ(右)",
  "聽力8000HZ(右)": "聽力8000HZ(右)",
  "眼壓(右眼)": "眼壓(右眼)",
  "眼壓(左眼)": "眼壓(左眼)",
  "作業經歷": "作業經歷",
  "泌尿系統": "泌尿系統",
  "口腔粘膜": "口腔粘膜",
  "未來十年心血管疾病風險評估指數": "未來十年心血管疾病風險評估指數",
  "其他": "其他",
  "呼吸系統(含鼻腔、鼻黏膜、鼻中膈穿孔)": "呼吸系統(含鼻腔、鼻黏膜、鼻中膈穿孔)",
  "平均每日睡眠時間": "平均每日睡眠時間",
  "皮膚黏膜(含口、鼻腔、眼睛結膜)": "皮膚黏膜(含口、鼻腔、眼睛結膜)",
  "淋巴血液系統(含淋巴結、肝脾腫大)": "淋巴血液系統(含淋巴結、肝脾腫大)",
  "過敏史": "過敏史",
  "用藥史": "用藥史",
  "家族史": "家族史",
  "尿蛋白": "尿蛋白",
  "尿糖": "尿糖",
  "尿膽素原": "尿膽素原",
  "尿膽紅素": "尿膽紅素",
  "尿比重": "尿比重",
  "尿白血球酯脢": "尿白血球酯脢",
  "尿潛血": "尿潛血",
  "尿酸鹼值": "尿酸鹼值",
  "尿酮體": "尿酮體",
  "尿亞硝酸": "尿亞硝酸",
  "尿紅血球": "尿紅血球",
  "尿白血球": "尿白血球",
  "上皮細胞": "上皮細胞",
  "尿圓柱體": "尿圓柱體",
  "結晶體 ": "結晶體 ",
  "黏液": "黏液",
  "尿中鎳": "尿中鎳",
  "尿中鉛": "尿中鉛",
  "尿中鎘": "尿中鎘",
  "尿中砷": "尿中砷",
  "糞便潛血ST-OB": "糞便潛血ST-OB",
  "糞便潛血(免疫法)FOBT": "糞便潛血(免疫法)FOBT",
  "尿濁度": "尿濁度",
  "傷寒檢測(糞便培養)": "傷寒檢測(糞便培養)",
  "微量白蛋白": "微量白蛋白",
  "肌酸酐(尿液)": "肌酸酐(尿液)",
  "ACR值": "ACR值",
  "VMA(Urine)": "VMA(Urine)", 
  "尿液蛋白定量": "尿液蛋白定量",
  "健保-糞便潛血檢查": "健保-糞便潛血檢查",
  "嗎啡(Morphine)": "嗎啡(Morphine)",
  "安非他命(Amphetamine)": "安非他命(Amphetamine)",
  "尿液細胞學檢查": "尿液細胞學檢查",
  "尿外觀": "尿外觀",
  "尿細菌": "尿細菌",
  "尿沉渣 ": "尿沉渣 ",
  "搖頭丸(MDMA Screen)": "搖頭丸(MDMA Screen)",
  "大麻(Cannabinoid)": "大麻(Cannabinoid)",
  "K他命(Ketamine Screen)": "K他命(Ketamine Screen)",
  "類胰島素生長因子IGF-1": "類胰島素生長因子IGF-1",
  "Growth Hormone": "Growth Hormone",
  "阿米巴痢疾": "阿米巴痢疾",
  "桿菌性痢疾": "桿菌性痢疾",
  "寄生蟲": "寄生蟲",
  "砷(尿)": "砷(尿)",
  "古柯鹼": "古柯鹼",
  "尼古丁": "尼古丁",
  "白血球(WBC)": "白血球(WBC)",
  "紅血球(RBC)": "紅血球(RBC)",
  "血色素(HB)": "血色素(HB)",
  "血球容積比(HCT)": "血球容積比(HCT)",
  "紅血球平均血紅素(MCH)": "紅血球平均血紅素(MCH)",
  "紅血球平均體積值(MCV)": "紅血球平均體積值(MCV)",
  "平均血色素濃度值(MCHC)": "平均血色素濃度值(MCHC)",
  "血小板計數": "血小板計數",
  "淋巴球百分比": "淋巴球百分比",
  "單核球百分比": "單核球百分比",
  "嗜中性白血球百分比": "嗜中性白血球百分比",
  "嗜伊紅白血球百分比": "嗜伊紅白血球百分比",
  "嗜鹼性白血球百分比": "嗜鹼性白血球百分比",
  "淋巴球數": "淋巴球數",
  "單核球數": "單核球數",
  "嗜中性球數": "嗜中性球數",
  "嗜酸性白血球數": "嗜酸性白血球數",
  "嗜鹼性白血球數": "嗜鹼性白血球數",
  "紅血球分布寬度": "紅血球分布寬度",
  "血小板分布寬度": "血小板分布寬度",
  "平均血小板容積": "平均血小板容積",
  "血小板容積比": "血小板容積比",
  "地中海貧血A1(HB-A1)": "地中海貧血A1(HB-A1)",
  "地中海貧血A2(HB-A2)": "地中海貧血A2(HB-A2)",
  "地中海貧血F(HB-F)": "地中海貧血F(HB-F)",
  "血中鉛Pb": "血中鉛Pb",
  "血中鎘Cd": "血中鎘Cd",
  "血中汞Hg": "血中汞Hg",
  "血型ABO": "血型ABO",
  "血型Rh type": "血型Rh type",
  "D型肝炎抗體HDV-Ab": "D型肝炎抗體HDV-Ab",
  "C-胜鏈胰島素": "C-胜鏈胰島素",
  "水痘帶狀皰疹病毒IgG": "水痘帶狀皰疹病毒IgG",
  "水痘帶狀皰疹病毒IgM": "水痘帶狀皰疹病毒IgM",
  "德國麻疹IgG": "德國麻疹IgG",
  "德國麻疹IgM": "德國麻疹IgM",
  "部份凝血活酵素時間APTT": "部份凝血活酵素時間APTT",
  "凝血酵素原時間PT": "凝血酵素原時間PT",
  "嗜酸性白血球數(手工)": "嗜酸性白血球數(手工)",
  "杜避炎": "杜避炎",
  "國際標準化比值INR": "國際標準化比值INR",
  "纖維蛋白原": "纖維蛋白原",
  "草酸轉氨基酵素SGOT": "草酸轉氨基酵素SGOT",
  "丙酮轉氨基酵素SGPT": "丙酮轉氨基酵素SGPT",
  "鹼性磷酸脢ALK-P": "鹼性磷酸脢ALK-P",
  "總蛋白T-P": "總蛋白T-P",
  "白蛋白ALB": "白蛋白ALB",
  "球蛋白GLO": "球蛋白GLO",
  "白蛋白/球蛋白比值(A/G)": "白蛋白/球蛋白比值(A/G)",
  "丙麩胺酸轉基酵素r-GT": "丙麩胺酸轉基酵素r-GT",
  "總膽紅素T-Bili": "總膽紅素T-Bili",
  "直接膽紅素D-Bili": "直接膽紅素D-Bili",
  "飯後血糖": "飯後血糖",
  "醣化血色素HbA1c": "醣化血色素HbA1c",
  "尿素氮BUN": "尿素氮BUN",
  "肌酸酐Creatinine": "肌酸酐Creatinine",
  "尿酸UA": "尿酸UA",
  "腎絲球過濾速率eGFR": "腎絲球過濾速率eGFR",
  "總膽固醇": "總膽固醇",
  "三酸甘油酯": "三酸甘油酯",
  "高密度脂蛋白膽固醇": "高密度脂蛋白膽固醇",
  "低密度脂蛋白膽固醇": "低密度脂蛋白膽固醇",
  "動脈硬化指數T-C/HDL-C": "動脈硬化指數T-C/HDL-C",
  "乳酸脫氫酵素LDH": "乳酸脫氫酵素LDH",
  "肌酸磷化酵素CPK": "肌酸磷化酵素CPK",
  "同半胱胺酸酵素(HCY)": "同半胱胺酸酵素(HCY)",
  "高敏度CRP(hs-CRP)": "高敏度CRP(hs-CRP)",
  "心肌旋轉蛋白Troponin-I": "心肌旋轉蛋白Troponin-I",
  "N端前腦利鈉尿太(NT-pro BNP)": "N端前腦利鈉尿太(NT-pro BNP)",
  "澱粉酵素Amylase": "澱粉酵素Amylase",
  "血清鈣Ca": "血清鈣Ca",
  "血清磷P": "血清磷P",
  "鈉Na": "鈉Na",
  "鉀K": "鉀K",
  "氯Cl": "氯Cl",
  "鎂Mg": "鎂Mg",
  "類風濕性關節因子RA": "類風濕性關節因子RA",
  "蠶豆症G-6-PD": "蠶豆症G-6-PD",
  "間接膽紅素": "間接膽紅素",
  "解脂酵素Lipase": "解脂酵素Lipase",
  "維他命B12": "維他命B12",
  "葉酸": "葉酸",
  "總膽固醇(廢液)": "總膽固醇(廢液)",
  "三酸甘油酯(廢液)": "三酸甘油酯(廢液)",
  "低密度膽固醇(廢液)": "低密度膽固醇(廢液)",
  "總膽固醇(淨後)": "總膽固醇(淨後)",
  "紅血球沈降速度測定(1hr)": "紅血球沈降速度測定(1hr)",
  "C肝病毒RNA定量HCV-RNA (PCR)": "C肝病毒RNA定量HCV-RNA (PCR)",
  "三酸甘油酯(淨後)": "三酸甘油酯(淨後)",
  "低密度膽固醇(淨後)": "低密度膽固醇(淨後)",
  "B肝病毒DNA定量HBV-DNA (PCR)": "B肝病毒DNA定量HBV-DNA (PCR)",
  "酒精性代謝基因(檢單)": "酒精性代謝基因(檢單)",
  "阿茲海默症基因APOE(檢單)": "阿茲海默症基因APOE(檢單)",
  "個人化代謝基因體篩檢-慢性病風險檢測": "個人化代謝基因體篩檢-慢性病風險檢測",
  "14項癌症風險評估(男性-同意書)": "14項癌症風險評估(男性-同意書)",
  "IMR阿茲海默症檢測(檢單)": "IMR阿茲海默症檢測(檢單)",
  "IMR PD帕金森氏症檢測(檢單)": "IMR PD帕金森氏症檢測(檢單)",
  "sdLDL超壞膽固醇": "sdLDL超壞膽固醇",
  "心臟危險因子LDL/HDL-C": "心臟危險因子LDL/HDL-C",
  "鋅": "鋅",
  "鉛": "鉛",
  "尿中汞": "尿中汞",
  "銅": "銅",
  "尿中鉻": "尿中鉻",
  "砷(血)": "砷(血)",
  "鋁": "鋁",
  "膽素脂脢": "膽素脂脢",
  "飯後血糖(1小時)": "飯後血糖(1小時)",
  "胃泌素釋放胜汰前體(ProGRP)": "銅胃泌素釋放胜汰前體(ProGRP)",
  "前列腺健康指數(PHI)": "前列腺健康指數(PHI)",
  "B型肝炎表面抗原HBsAg": "B型肝炎表面抗原HBsAg",
  "B型肝炎表面抗體HBsAb": "B型肝炎表面抗體HBsAb",
  "B型肝炎e抗原HBeAg": "B型肝炎e抗原HBeAg",
  "B型肝炎e抗體HBeAb": "B型肝炎e抗體HBeAb",
  "B型肝炎核心抗體Anti-HBc": "B型肝炎核心抗體Anti-HBc",
  "C型肝炎抗體HCV-Ab": "C型肝炎抗體HCV-Ab",
  "A型肝炎IgG(HAV-IgG)": "A型肝炎IgG(HAV-IgG)",
  "A型肝炎IgM(HAV-IgM)": "A型肝炎IgM(HAV-IgM)",
  "幽門螺旋桿菌Heli-P": "幽門螺旋桿菌Heli-P",
  "α-胎兒蛋白AFP": "α-胎兒蛋白AFP",
  "大腸癌胚抗原CEA": "大腸癌胚抗原CEA",
  "胰臟癌CA-199": "胰臟癌CA-199",
  "攝護腺特異抗原PSA": "攝護腺特異抗原PSA",
  "卵巢癌篩檢CA-125": "卵巢癌篩檢CA-125",
  "乳癌篩檢CA-153": "乳癌篩檢CA-153",
  "鼻咽癌篩檢EBV-IgA": "鼻咽癌篩檢EBV-IgA",
  "睪丸癌β-HCG": "睪丸癌β-HCG",
  "絨毛膜癌β-HCG": "絨毛膜癌β-HCG",
  "小細胞肺癌篩檢NSE": "小細胞肺癌篩檢NSE",
  "胃癌篩檢CA72-4": "胃癌篩檢CA72-4",
  "微小球蛋白β2-M": "微小球蛋白β2-M",
  "鱗狀上皮細胞癌SCC": "鱗狀上皮細胞癌SCC",
  "非小細胞肺癌篩檢Cyfra 21-1": "非小細胞肺癌篩檢Cyfra 21-1",
  "腫瘤多胜脢抗原（TPA)": "腫瘤多胜脢抗原（TPA)",
  "三碘甲狀腺素T3": "三碘甲狀腺素T3",
  "四碘甲狀腺素T4": "四碘甲狀腺素T4",
  "甲狀腺刺激素TSH": "甲狀腺刺激素TSH",
  "游離四碘甲狀腺素FreeT4": "游離四碘甲狀腺素FreeT4",
  "濾泡刺激素FSH": "濾泡刺激素FSH",
  "促黃體素LH": "促黃體素LH",
  "動情素E2": "動情素E2",
  "泌乳激素Prolactin": "泌乳激素Prolactin",
  "助孕酮Progesterone": "助孕酮Progesterone",
  "睪固酮Testosterone": "睪固酮Testosterone",
  "免疫球蛋白IgE": "免疫球蛋白IgE",
  "胰島素阻抗": "胰島素阻抗",
  "抗細胞核抗體ANA": "抗細胞核抗體ANA",
  "梅毒血清檢查RPR(STS)": "梅毒血清檢查RPR(STS)",
  "梅毒螺旋體檢查TPHA(TPPA)": "梅毒螺旋體檢查TPHA(TPPA)",
  "愛滋病毒篩檢HIV": "愛滋病毒篩檢HIV",
  "麻疹病毒抗體IgG": "麻疹病毒抗體IgG",
  "血清鐵S-Iron": "血清鐵S-Iron",
  "血清鐵和總鐵結合能TIBC": "血清鐵和總鐵結合能TIBC",
  "鐵蛋白": "鐵蛋白",
  "副傷寒檢測Weil-FelixOX19": "副傷寒檢測Weil-FelixOX19",
  "沙門桿菌H型凝集素Salmonella-H": "沙門桿菌H型凝集素Salmonella-H",
  "沙門桿菌O型凝集素Salmonella-O": "沙門桿菌O型凝集素Salmonella-O",
  "副傷寒檢測Weil-FelixOX2": "副傷寒檢測Weil-FelixOX2",
  "副傷寒檢測Weil-FelixOXK": "副傷寒檢測Weil-FelixOXK",
  "C13尿素呼氣幽門桿菌檢查": "C13尿素呼氣幽門桿菌檢查",
  "傷寒檢測Widal": "傷寒檢測Widal",
  "皮質醇Cortisol(AM)": "皮質醇Cortisol(AM)",
  "還原雄性素硫化物DHEA-S": "還原雄性素硫化物DHEA-S",
  "胰島素": "胰島素",
  "游離睪丸酮": "游離睪丸酮",
  "性荷爾蒙結合球蛋白": "性荷爾蒙結合球蛋白",
  "僵直性脊椎炎(HLA-B27)": "僵直性脊椎炎(HLA-B27)",
  "維他命D": "維他命D",
  "過敏原檢查66": "過敏原檢查66",
  "過敏原檢查110": "過敏原檢查110",
  "過敏原檢查101": "過敏原檢查101",
  "過敏原檢查224": "過敏原檢查224",
  "抗平滑肌抗體ASMA": "抗平滑肌抗體ASMA",
  "抗甲狀腺過氧化脢抗體(Anti-TPO)": "抗甲狀腺過氧化脢抗體(Anti-TPO)",
  "甲狀腺球蛋白抗體(Anti-TG)": "甲狀腺球蛋白抗體(Anti-TG)",
  "核抗體Anti-ENA SS-A(RO)": "核抗體Anti-ENA SS-A(RO)",
  "紅血球沈降速度測定(2hr)": "紅血球沈降速度測定(2hr)",
  "醛固酮Aldosterone": "醛固酮Aldosterone",
  "促腎上腺皮質素ACTH": "促腎上腺皮質素ACTH",
  "過敏原檢查40": "過敏原檢查40",
  "肺炎黴漿菌": "肺炎黴漿菌",
  "粒線體抗體AMA": "粒線體抗體AMA",
  "抗甲狀腺素AntiTSH": "抗甲狀腺素AntiTSH",
  "愛滋病第一型核酸HIV-1 RNA": "愛滋病第一型核酸HIV-1 RNA",
  "人類T型淋巴病毒抗體Anti-HTLV": "人類T型淋巴病毒抗體Anti-HTLV",
  "巨細胞病毒抗體Anti-CMV IgG": "巨細胞病毒抗體Anti-CMV IgG",
  "巨細胞病毒抗體Anti-CMV IgM": "巨細胞病毒抗體Anti-CMV IgM",
  "抗磷脂抗體Anti-phospholipid antibody": "抗磷脂抗體Anti-phospholipid antibody",
  "皮質醇Cortisol(PM)": "皮質醇Cortisol(PM)",
  "傷寒(Widal Typhoid O)": "傷寒(Widal Typhoid O)",
  "傷寒(Widal Typhoid H)": "傷寒(Widal Typhoid H)",
  "傷寒(Widal Paratyphi A)": "傷寒(Widal Paratyphi A)",
  "傷寒(Widal Paratyphi B)": "傷寒(Widal Paratyphi B)",
  "Free T3": "Free T3",
  "弓漿蟲": "弓漿蟲",
  "免疫球蛋白D(IgD)": "免疫球蛋白D(IgD)",
  "免疫球蛋白G(IgG)": "免疫球蛋白G(IgG)",
  "免疫球蛋白M(IgM)": "免疫球蛋白M(IgM)",
  "肝癌腫瘤標記PIVKA-II": "肝癌腫瘤標記PIVKA-II",
  "anti-dsDNA": "anti-dsDNA",
  "Intact副甲狀線激素": "Intact副甲狀線激素",
  "游離攝護腺特異抗原": "游離攝護腺特異抗原",
  "攝護腺特異指原前驅物": "攝護腺特異指原前驅物",
  "三碘甲狀腺吸收率": "三碘甲狀腺吸收率",
  "體脂肪": "體脂肪",
  "腳踝骨質密度": "腳踝骨質密度",
  "靜式心電圖EKG": "靜式心電圖EKG",
  "腹部超音波": "腹部超音波",
  "攝護腺超音波": "攝護腺超音波",
  "乳房超音波": "乳房超音波",
  "骨盆腔婦科超音波": "骨盆腔婦科超音波",
  "甲狀腺超音波": "甲狀腺超音波",
  "頸動脈超音波": "頸動脈超音波",
  "心臟超音波Cardiac echo": "心臟超音波",
  "心臟超音波": "心臟超音波",
  "全身體脂肪分析": "全身體脂肪分析",
  "雙能量X光骨質吸收儀(DXA)": "雙能量X光骨質吸收儀(DXA)",
  "肺活量(VC)": "肺活量(VC)",
  "肺功能FVC": "肺功能FVC",
  "肺功能FEV1.0": "肺功能FEV1.0",
  "肺功能FEV1%(G)": "肺功能FEV1%(G)",
  "無痛大腸鏡檢查": "無痛大腸鏡檢查",
  "無痛胃鏡檢查": "無痛胃鏡檢查",
  "胃鏡檢查": "胃鏡檢查",
  "大腸鏡檢查": "大腸鏡檢查",
  "胸部CXR": "胸部CXR",
  "腹部KUB": "腹部KUB",
  "頸椎X光-正面": "頸椎X光-正面",
  "頸椎X光-側面": "頸椎X光-側面",
  "胸椎X光-側面": "胸椎X光-側面",
  "胸椎X光-正面": "胸椎X光-正面",
  "腰椎X光-正面(L-spine AP)": "腰椎X光-正面(L-spine AP)",
  "腰椎X光-側面(L-spine Lat)": "腰椎X光-側面(L-spine Lat)",
  "心腦血管彈性分析(APG)": "心腦血管彈性分析(APG)",
  "自律神經檢測(HRV)": "自律神經檢測(HRV)",
  "LF／HF自律神經平衡訊息": "LF／HF自律神經平衡訊息",
  "PSI壓力指數": "PSI壓力指數",
  "無痛腸胃鏡檢查": "無痛腸胃鏡檢查",
  "有感腸胃鏡檢查": "有感腸胃鏡檢查",
  "胸部數位雙能量減影": "胸部數位雙能量減影",
  "頭部數位斷層合成攝影": "頭部數位斷層合成攝影",
  "頸部數位斷層合成攝影": "頸部數位斷層合成攝影",
  "胸部數位斷層合成攝影": "胸部數位斷層合成攝影",
  "腹部數位斷層合成攝影": "腹部數位斷層合成攝影",
  "全脊椎數位X光攝影": "全脊椎數位X光攝影",
  "下肢數位X光攝影": "下肢數位X光攝影",
  "病理報告": "病理報告",
  "一般抹片": "一般抹片",
  "新柏氏抹片(超薄抹片)": "新柏氏抹片(超薄抹片)",
  "HPV人類乳突病毒": "HPV人類乳突病毒",
  "InBody體脂肪機": "InBody體脂肪機",
  "左手X光": "左手X光",
  "右手X光": "右手X光",
  "乙狀結腸": "乙狀結腸",
  "精液檢查": "精液檢查",
  "胃鏡病理報告": "胃鏡病理報告",
  "雙能量X光骨質吸收儀(DXA)-髖關節": "雙能量X光骨質吸收儀(DXA)-髖關節",
  "大腸鏡病理報告": "大腸鏡病理報告",
  "精液酸鹼值 (Sperm PH)": "精液酸鹼值 (Sperm PH)",
  "精液量 (Sperm Volume)": "精液量 (Sperm Volume)",
  "精液外觀 (Semen Appearance)": "精液外觀 (Semen Appearance)",
  "精蟲數量 (Sperm Count)": "精蟲數量 (Sperm Count)",
  "精蟲型態 (Morphology)": "精蟲型態 (Morphology)",
  "活動力30分鐘 (Motility(30min))": "活動力30分鐘 (Motility(30min))",
  "精液白血球 (SPER WBC)": "精液白血球 (SPER WBC)",
  "精液紅血球 (SPE RBC)": "精液紅血球 (SPE RBC)",
  "淋病雙球菌DNA": "淋病雙球菌DNA",
  "砂眼披衣菌": "砂眼披衣菌",
  "胃黏膜幽門螺旋桿菌快篩檢測": "胃黏膜幽門螺旋桿菌快篩檢測",
  "雙能量X光骨質吸收儀(DXA)-腰椎": "雙能量X光骨質吸收儀(DXA)-腰椎",
  "全自動乳房掃描": "全自動乳房掃描",
  "胸部CXR-側面": "胸部CXR-側面",
  "其他超音波": "其他超音波",
  "右膝正側面+MERCHANT": "右膝正側面+MERCHANT",
  "左膝正側面+MERCHANT": "左膝正側面+MERCHANT",
  "肩胛骨X光-正面": "肩胛骨X光-正面",
  "肩胛骨X光-側面": "肩胛骨X光-側面",
  "頭部電腦斷層掃描CT": "頭部電腦斷層掃描CT",
  "頸部電腦斷層掃描CT": "頸部電腦斷層掃描CT",
  "腹部電腦斷層掃描CT": "腹部電腦斷層掃描CT",
  "骨盆電腦斷層掃描CT": "骨盆電腦斷層掃描CT",
  "肺部低劑量癌篩CT": "肺部低劑量癌篩CT",
  "頭部核磁共振MRI": "頭部核磁共振MRI",
  "頸部核磁共振MRI": "頸部核磁共振MRI",
  "腹部核磁共振MRI": "腹部核磁共振MRI",
  "骨盆核磁共振MRI": "骨盆核磁共振MRI",
  "頸椎核磁共振MRI": "頸椎核磁共振MRI",
  "胸椎核磁共振MRI": "胸椎核磁共振MRI",
  "腰椎核磁共振MRI": "腰椎核磁共振MRI",
  "全脊椎核磁共振MRI": "全脊椎核磁共振MRI",
  "全身核磁共振MRI": "全身核磁共振MRI",
  "左肩關節核磁共振MRI": "左肩關節核磁共振MRI",
  "乳房核磁共振MRI": "乳房核磁共振MRI",
  "薦椎核磁共振MRI": "薦椎核磁共振MRI",
  "兒童版腳踝骨質密度": "兒童版腳踝骨質密度",
  "髖關節X光正面(左)": "髖關節X光正面(左)",
  "髖關節X光正面(右)": "髖關節X光正面(右)",
  "RMSSD心臟負荷指數": "RMSSD心臟負荷指數",
  "(健保)HPV人類乳突病毒": "(健保)HPV人類乳突病毒",
  "(健保)一般抹片": "(健保)一般抹片",
  "小腿X光(正面)": "小腿X光(正面)",
  "小腿X光(左腳)": "小腿X光(左腳)",
  "小腿X光(右腳)": "小腿X光(右腳)",
  "膝蓋X光-正面": "膝蓋X光-正面",
  "膝蓋X光-側面(左)": "膝蓋X光-側面(左)",
  "膝蓋X光-側面(右)": "膝蓋X光-側面(右)",
  "DXA 檢查":"DXA 檢查",
  //Ary02(Suggestion)
  "血壓偏低,若無任何症狀勿需藥物治療,請運動過後補充水分,以免造成脫水引起低血壓。": "血壓偏低,若無任何症狀勿需藥物治療,請運動過後補充水分,以免造成脫水引起低血壓。",
  "血壓偏低,若無任何症狀勿需藥物治療,請運動過後補充水分,以免造成脫水引起低血壓。若出現頭昏眼花,倦怠無力,心悸,食慾不振等症狀,請配合臨床症狀和血壓數值變化至家庭醫學科或心臟內科門診追蹤檢查。":"血壓偏低,若無任何症狀勿需藥物治療,請運動過後補充水分,以免造成脫水引起低血壓。若出現頭昏眼花,倦怠無力,心悸,食慾不振等症狀,請配合臨床症狀和血壓數值變化至家庭醫學科或心臟內科門診追蹤檢查。",
  "血壓量測值異常,建議均衡飲食,適度運動(數值偏高者,建議清淡限鹽飲食並規則量測血壓,務必控制血壓於安全範圍,若持續血壓控制不佳時需留意不適宜從事之工作內容如輪班夜班作業等),並配合臨床症狀和血壓數值變化至家庭醫學科或心臟內科門診追蹤治療。": "血壓量測值異常,建議均衡飲食,適度運動(數值偏高者,建議清淡限鹽飲食並規則量測血壓,務必控制血壓於安全範圍,若持續血壓控制不佳時需留意不適宜從事之工作內容如輪班夜班作業等),並配合臨床症狀和血壓數值變化至家庭醫學科或心臟內科門診追蹤治療。",
  "裸視 [右眼] : 裸視視力不良  請至眼科門診做視力保健或配戴眼鏡矯正您的視力。": "裸視 [右眼] : 裸視視力不良  請至眼科門診做視力保健或配戴眼鏡矯正您的視力。",
  "裸視 [左眼] : 裸視視力不良  請至眼科門診做視力保健或配戴眼鏡矯正您的視力。": "裸視 [左眼] : 裸視視力不良  請至眼科門診做視力保健或配戴眼鏡矯正您的視力。",
  "矯正 [右眼] : 矯正視力不良，若有視力變化，請至眼科門診追蹤檢查或重新矯正視力。": "矯正 [右眼] : 矯正視力不良，若有視力變化，請至眼科門診追蹤檢查或重新矯正視力。",
  "矯正 [左眼] : 矯正視力不良，若有視力變化，請至眼科門診追蹤檢查或重新矯正視力。": "矯正 [左眼] : 矯正視力不良，若有視力變化，請至眼科門診追蹤檢查或重新矯正視力。",
  "辨色力異常，請配合病史視需要至眼科追蹤。": "辨色力異常，請配合病史視需要至眼科追蹤。",
  "BMI<18.5：體重過輕，建議飲食均衡之前提下，增加熱量攝取，請至家庭醫學科門診定期評估。": "BMI<18.5：體重過輕，建議飲食均衡之前提下，增加熱量攝取，請至家庭醫學科門診定期評估。",
  "BMI>24：體重過重，建議改變生活型態並控制體重於正常範圍，宜至家庭醫學科門診定期評估。": "BMI>24：體重過重，建議改變生活型態並控制體重於正常範圍，宜至家庭醫學科門診定期評估。",
  "腰圍：男生>90公分，女生>80公分，疑代謝症候群，減重、多運動、飲食控制，注意血糖、血脂肪，每年健檢追蹤。": "腰圍：男生>90公分，女生>80公分，疑代謝症候群，減重、多運動、飲食控制，注意血糖、血脂肪，每年健檢追蹤。",
  "脈搏異常，如有突然頭暈、胸悶、呼吸困難、乏力等現象，請盡速就醫。": "脈搏異常，如有突然頭暈、胸悶、呼吸困難、乏力等現象，請盡速就醫。",
  "AMH 愈高表示卵巢在未來可供使用的卵子存量愈豐沛，愈低表示卵子存量有限，因此AMH對於預測卵巢庫存有顯著相關，但AMH 僅代表卵的數目多少，並不代表品質，若對於有懷孕計劃的婦女來說，仍需與醫師做討論以訂下最適合的助孕療程。": "AMH 愈高表示卵巢在未來可供使用的卵子存量愈豐沛，愈低表示卵子存量有限，因此AMH對於預測卵巢庫存有顯著相關，但AMH 僅代表卵的數目多少，並不代表品質，若對於有懷孕計劃的婦女來說，仍需與醫師做討論以訂下最適合的助孕療程。",
  "抗精蟲抗體在男性和女性體內都可能出現，它會減緩精蟲的活動力，或造成精蟲聚集，影響受精過程中每一個環節的成功機率。當男性輸精管阻塞、睾丸損傷、炎症、慢性前列腺疾病時，精液就可能滲漏到外圍組織中去，如進入血循環或淋巴系統，從而激活免疫系統引起免疫應答，產生自身抗精子抗體(Antisperm antibody，ASA)。": "抗精蟲抗體在男性和女性體內都可能出現，它會減緩精蟲的活動力，或造成精蟲聚集，影響受精過程中每一個環節的成功機率。當男性輸精管阻塞、睾丸損傷、炎症、慢性前列腺疾病時，精液就可能滲漏到外圍組織中去，如進入血循環或淋巴系統，從而激活免疫系統引起免疫應答，產生自身抗精子抗體(Antisperm antibody，ASA)。",
  "眼壓(右眼)異常，可能受角膜厚度或其他因素影響，請保持生活規律、避免熬夜及適當視神經及視野放鬆，如有不適請至眼科追蹤檢查。": "眼壓(右眼)異常，可能受角膜厚度或其他因素影響，請保持生活規律、避免熬夜及適當視神經及視野放鬆，如有不適請至眼科追蹤檢查。",
  "眼壓(左眼)異常，可能受角膜厚度或其他因素影響，請保持生活規律、避免熬夜及適當視神經及視野放鬆，如有不適請至眼科追蹤檢查。": "眼壓(左眼)異常，可能受角膜厚度或其他因素影響，請保持生活規律、避免熬夜及適當視神經及視野放鬆，如有不適請至眼科追蹤檢查。",
  "此次未來十年心血管疾病風險評估指數為低危險性。但若您有已知之心血管疾病或患有糖尿病無論計算後之心血發生率多少，您皆視同為高危險族群(10年危險性>20%)。": "此次未來十年心血管疾病風險評估指數為低危險性。但若您有已知之心血管疾病或患有糖尿病無論計算後之心血發生率多少，您皆視同為高危險族群(10年危險性>20%)。",
  "建議此次未來十年心血管疾病風險評估指數為中危險性。但若您有已知之心血管疾病或患有糖尿病無論計算後之心血發生率多少，您皆視同為高危險族群(10年危險性>20%)。建議每6-12個月至家醫科追蹤評估。": "建議此次未來十年心血管疾病風險評估指數為中危險性。但若您有已知之心血管疾病或患有糖尿病無論計算後之心血發生率多少，您皆視同為高危險族群(10年危險性>20%)。建議每6-12個月至家醫科追蹤評估。",
  "尿蛋白異常，可分為生理性例如脫水、發燒、直立性(姿勢性)蛋白尿等，及病理性蛋白尿，建議至腎臟科門診追蹤檢查，以排除生理性所造成的尿蛋白異常。": "尿蛋白異常，可分為生理性例如脫水、發燒、直立性(姿勢性)蛋白尿等，及病理性蛋白尿，建議至腎臟科門診追蹤檢查，以排除生理性所造成的尿蛋白異常。",
  "尿糖多發生在糖尿病病人，也可見於其他內分系失調、其他腦病變、燒燙傷、感染、肥胖、心肌梗塞、懷孕等患者，偶爾多吃甜食也可能發生短暫性糖尿的情形；異常請至家庭醫學科或新陳代謝科門診追蹤檢查": "尿糖多發生在糖尿病病人，也可見於其他內分系失調、其他腦病變、燒燙傷、感染、肥胖、心肌梗塞、懷孕等患者，偶爾多吃甜食也可能發生短暫性糖尿的情形；異常請至家庭醫學科或新陳代謝科門診追蹤檢查",
  "尿膽素原在腸中經細菌作用形成尿膽素原， 若尿中尿膽素原過高，表示可能有溶血性黃疸、急性肝炎、肝硬化等疾病，飲食不規律或作息不正常也可能造成弱陽性，建議至肝膽腸胃科門診追蹤。": "尿膽素原在腸中經細菌作用形成尿膽素原， 若尿中尿膽素原過高，表示可能有溶血性黃疸、急性肝炎、肝硬化等疾病，飲食不規律或作息不正常也可能造成弱陽性，建議至肝膽腸胃科門診追蹤。",
  "尿膽紅素為衰老紅血球中血色素的分解產物, 正常尿中沒有膽紅素, 為陰性(－)，當尿中膽紅素呈陽性(＋)，表示可能有膽道阻塞或肝臟疾病等，另外過度飢餓、節食、飲酒過量也可能造成偽陽性，建議至肝膽腸胃科門診追蹤。": "尿膽紅素為衰老紅血球中血色素的分解產物, 正常尿中沒有膽紅素, 為陰性(－)，當尿中膽紅素呈陽性(＋)，表示可能有膽道阻塞或肝臟疾病等，另外過度飢餓、節食、飲酒過量也可能造成偽陽性，建議至肝膽腸胃科門診追蹤。",
  "尿液比重會隨者水分攝取的多寡而有變化，發燒、大量流汗、嘔吐等可能增加，尿崩症、腎絲球腎炎、腎盂腎炎則會減少；異常請至泌尿科或婦產科門診追蹤檢查": "尿液比重會隨者水分攝取的多寡而有變化，發燒、大量流汗、嘔吐等可能增加，尿崩症、腎絲球腎炎、腎盂腎炎則會減少；異常請至泌尿科或婦產科門診追蹤檢查",
  "尿白血球酯脢異常，可能有泌尿道感染，也有可能是取樣污染，或是非病菌所造成的偽陽性，須搭配其他尿液檢查結果做綜合判斷，如有不適請至泌尿科或婦產科門診追蹤檢查": "尿白血球酯脢異常，可能有泌尿道感染，也有可能是取樣污染，或是非病菌所造成的偽陽性，須搭配其他尿液檢查結果做綜合判斷，如有不適請至泌尿科或婦產科門診追蹤檢查",
  "尿潛血反應陽性，可能泌尿道感染或結石存在或女性生理期間，如有不適請至泌尿科或婦產科門診追蹤檢查": "尿潛血反應陽性，可能泌尿道感染或結石存在或女性生理期間，如有不適請至泌尿科或婦產科門診追蹤檢查",
  "尿酸鹼值異常,尿路感染時，會使用重碳酸鈉的藥物，使尿偏向鹼性；素食者多攝取青菜水果，也會使尿偏向鹼性；異常請至泌尿科或婦產科門診追蹤檢查": "尿酸鹼值異常,尿路感染時，會使用重碳酸鈉的藥物，使尿偏向鹼性；素食者多攝取青菜水果，也會使尿偏向鹼性；異常請至泌尿科或婦產科門診追蹤檢查",
  "尿液酮體為體內脂肪代謝不完全產物,正常尿中沒有酮體為陰性,若為陽性,常見於糖尿病患者,但也見於飢餓、發燒、甲狀腺機能亢進、懷孕等。如為陽性且非病理性因素(例如:飢餓、懷孕)，觀察即可，如有不適請至家庭醫學科或腎臟科門診追蹤檢查": "尿液酮體為體內脂肪代謝不完全產物,正常尿中沒有酮體為陰性,若為陽性,常見於糖尿病患者,但也見於飢餓、發燒、甲狀腺機能亢進、懷孕等。如為陽性且非病理性因素(例如:飢餓、懷孕)，觀察即可，如有不適請至家庭醫學科或腎臟科門診追蹤檢查",
  "尿亞硝酸陽性表示細菌存在於尿液中，或是尿液久置的結果;異常請至泌尿科或婦產科門診追蹤檢查": "尿亞硝酸陽性表示細菌存在於尿液中，或是尿液久置的結果;異常請至泌尿科或婦產科門診追蹤檢查",
  "尿紅血球出現與泌尿道感染或結石存在或是女性生理期間有關，請至泌尿科或婦產科門診追蹤檢查": "尿紅血球出現與泌尿道感染或結石存在或是女性生理期間有關，請至泌尿科或婦產科門診追蹤檢查",
  "尿白血球出現與尿路感染有關，請至泌尿科或婦產科門診追蹤檢查": "尿白血球出現與尿路感染有關，請至泌尿科或婦產科門診追蹤檢查",
  "尿液出現上皮細胞可能與女性陰道感染、腎臟膀胱尿道感染有關，也有可能是非中段尿所造成的偏高，必須配合其他指數作判讀，如有不適請至泌尿科或婦產科門診追蹤檢查": "尿液出現上皮細胞可能與女性陰道感染、腎臟膀胱尿道感染有關，也有可能是非中段尿所造成的偏高，必須配合其他指數作判讀，如有不適請至泌尿科或婦產科門診追蹤檢查",
  "尿圓柱體出現代表腎臟受有急性或持續慢性的傷害有關，建議至腎臟科門診追蹤檢查": "尿圓柱體出現代表腎臟受有急性或持續慢性的傷害有關，建議至腎臟科門診追蹤檢查",
  "尿液檢查出現結晶體，正常人或結石患者尿中皆可能出現不同的結晶體，尿液中的結晶體會隨濃度、溫度及PH值而改變，如有不適，請至泌尿科或婦產科門診追蹤檢查": "尿液檢查出現結晶體，正常人或結石患者尿中皆可能出現不同的結晶體，尿液中的結晶體會隨濃度、溫度及PH值而改變，如有不適，請至泌尿科或婦產科門診追蹤檢查",
  "尿粘液少量，觀察即可，若粘液形成增加，有可能是腎結石，尿道炎症等，需搭配其他尿液數據判斷，如有不適請至泌尿科或婦產科門診追蹤檢查": "尿粘液少量，觀察即可，若粘液形成增加，有可能是腎結石，尿道炎症等，需搭配其他尿液數據判斷，如有不適請至泌尿科或婦產科門診追蹤檢查",
  "糞便檢查潛血反應異常，請至肝膽腸胃科或家庭醫學科門診追蹤檢查。":"糞便檢查潛血反應異常，請至肝膽腸胃科或家庭醫學科門診追蹤檢查。",
  "糞便潛血(免疫法)FOBT主要用於檢測糞便中的人體血紅素濃度，以供大腸直腸癌之篩檢、診斷和治療追蹤；糞便檢查潛血反應呈陽性，建議可至本診所追蹤胃鏡大腸鏡檢查。": "糞便潛血(免疫法)FOBT主要用於檢測糞便中的人體血紅素濃度，以供大腸直腸癌之篩檢、診斷和治療追蹤；糞便檢查潛血反應呈陽性，建議可至本診所追蹤胃鏡大腸鏡檢查。",
  "尿液濁度與水分攝取量、食物、藥物影響或女性生理期有關，如異常請至泌尿科或婦產科門診追蹤檢查。": "尿液濁度與水分攝取量、食物、藥物影響或女性生理期有關，如異常請至泌尿科或婦產科門診追蹤檢查。",
  "微量白蛋白上升於急性腎小管壞死、嚴重貧血、心臟血管傷害、腎陰性尿崩症、腎絲球病變、中樞神經受損、癲癇、腹睪炎、運動、發炎、中毒、腎血管栓塞、泌尿道腫瘤、鏈球菌感染、SLE、妊娠毒血症、白血病、藥物等；異常請至腎臟科門診追蹤檢查。": "微量白蛋白上升於急性腎小管壞死、嚴重貧血、心臟血管傷害、腎陰性尿崩症、腎絲球病變、中樞神經受損、癲癇、腹睪炎、運動、發炎、中毒、腎血管栓塞、泌尿道腫瘤、鏈球菌感染、SLE、妊娠毒血症、白血病、藥物等；異常請至腎臟科門診追蹤檢查。",
  "尿液外觀(顏色-濁度)與水分攝取量、食物、藥物影響或女性生理期有關，如異常請至泌尿科或婦產科門診追蹤檢查。": "尿液外觀(顏色-濁度)與水分攝取量、食物、藥物影響或女性生理期有關，如異常請至泌尿科或婦產科門診追蹤檢查。",
  "白血球下降於感染、脾臟疾病、血液骨髓疾病或藥物引起；異常請至家庭醫學科門診追蹤檢查。": "白血球下降於感染、脾臟疾病、血液骨髓疾病或藥物引起；異常請至家庭醫學科門診追蹤檢查。",
  "白血球上升於感染、發炎、血液骨髓疾病及其他疾病；異常請至家庭醫學科門診追蹤檢查。": "白血球上升於感染、發炎、血液骨髓疾病及其他疾病；異常請至家庭醫學科門診追蹤檢查。",
  "紅血球下降於貧血、血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。": "紅血球下降於貧血、血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。",
  "紅血球上升於空腹檢驗、脫水、血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。": "紅血球上升於空腹檢驗、脫水、血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。",
  "血色素下降於缺鐵性貧血、海洋性貧血、慢性血液流失或其他血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。": "血色素下降於缺鐵性貧血、海洋性貧血、慢性血液流失或其他血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。",
  "血色素上升於空腹檢驗、脫水、血液骨髓疾病、慢性心肺疾病；異常請至家庭醫學科門診追蹤檢查。": "血色素上升於空腹檢驗、脫水、血液骨髓疾病、慢性心肺疾病；異常請至家庭醫學科門診追蹤檢查。",
  "血球容積比下降於貧血、溶血、血液骨髓疾病、慢性肝病；異常請至家庭醫學科門診追蹤檢查。": "血球容積比下降於貧血、溶血、血液骨髓疾病、慢性肝病；異常請至家庭醫學科門診追蹤檢查。",
  "血球容積比上升於脫水、血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。": "血球容積比上升於脫水、血液骨髓疾病；異常請至家庭醫學科門診追蹤檢查。",
  "紅血球平均血紅素下降於小球性貧血(包含缺鐵性貧血與海洋性貧血)；異常請至家庭醫學科門診追蹤檢查。": "紅血球平均血紅素下降於小球性貧血(包含缺鐵性貧血與海洋性貧血)；異常請至家庭醫學科門診追蹤檢查。",
  "紅血球平均血紅素上升於大球性貧血(包含惡性貧血與失血性貧血)；異常請至家庭醫學科門診追蹤檢查。": "紅血球平均血紅素上升於大球性貧血(包含惡性貧血與失血性貧血)；異常請至家庭醫學科門診追蹤檢查。",
  "紅血球平均體積值下降於缺鐵性貧血、海洋性貧血、慢性血液流失；異常請至家庭醫學科門診追蹤檢查。": "紅血球平均體積值下降於缺鐵性貧血、海洋性貧血、慢性血液流失；異常請至家庭醫學科門診追蹤檢查。",
  "紅血球平均體積值上升於葉酸或維生素B12缺乏、酗酒、慢性肝病；異常請至家庭醫學科門診追蹤檢查。": "紅血球平均體積值上升於葉酸或維生素B12缺乏、酗酒、慢性肝病；異常請至家庭醫學科門診追蹤檢查。",
  "平均血色素濃度值下降於各種貧血；異常請至家庭醫學科門診追蹤檢查。": "平均血色素濃度值下降於各種貧血；異常請至家庭醫學科門診追蹤檢查。",
  "平均血色素濃度值上升於遺傳性球狀紅血球等；異常請至家庭醫學科門診追蹤檢查。": "平均血色素濃度值上升於遺傳性球狀紅血球等；異常請至家庭醫學科門診追蹤檢查。",
  "血小板計數下降於血液骨髓疾病、感染、藥物影像、慢性肝病及脾臟疾病；異常請至家庭醫學科門診追蹤檢查。": "血小板計數下降於血液骨髓疾病、感染、藥物影像、慢性肝病及脾臟疾病；異常請至家庭醫學科門診追蹤檢查。",
  "血小板計數上升於血液骨髓疾病、感染、脾臟切除、惡性腫瘤；異常請至家庭醫學科門診追蹤檢查。": "血小板計數上升於血液骨髓疾病、感染、脾臟切除、惡性腫瘤；異常請至家庭醫學科門診追蹤檢查。",
  "淋巴球數下降於細菌感染時(比例上減少)，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。": "淋巴球數下降於細菌感染時(比例上減少)，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。",
  "淋巴球比例偏高通常代表是病毒感染(如感冒、腸胃炎、肝炎等)，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。": "淋巴球比例偏高通常代表是病毒感染(如感冒、腸胃炎、肝炎等)，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。",
  "單核球下降，可能與藥物治療有關，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。": "單核球下降，可能與藥物治療有關，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。",
  "單核球升高，數值偏高可能是身體發炎反應或EB病毒感染造成，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。": "單核球升高，數值偏高可能是身體發炎反應或EB病毒感染造成，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。",
  "嗜中性白血球偏低，可能有再生性不良貧血或藥物作用淋巴球增多，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指或及其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。": "嗜中性白血球偏低，可能有再生性不良貧血或藥物作用淋巴球增多，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指或及其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。",
  "嗜中性白血球偏高，可能是病毒或細菌感染、炎症或骨髓增殖症，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。": "嗜中性白血球偏高，可能是病毒或細菌感染、炎症或骨髓增殖症，需搭配白血球指數，及其他白血球分類細胞綜合判斷，如果白血球指數或其他分類異常，請至血液科門診追蹤檢查，如無不適觀察即可。",
  "嗜酸性白血球數下降，通常較無臨床意義，觀察即可，如有不適請至血液科門診追蹤檢查。": "嗜酸性白血球數下降，通常較無臨床意義，觀察即可，如有不適請至血液科門診追蹤檢查。",
  "嗜酸性白血球數上升於氣喘、濕疹等過敏、寄生蟲、瘧疾；異常請至家庭醫學科門診追蹤檢查。": "嗜酸性白血球數上升於氣喘、濕疹等過敏、寄生蟲、瘧疾；異常請至家庭醫學科門診追蹤檢查。",
  "嗜鹼性白血球數下降，通常較無臨床意義，觀察即可，如有不適請至血液科門診追蹤檢查。": "嗜鹼性白血球數下降，通常較無臨床意義，觀察即可，如有不適請至血液科門診追蹤檢查。",
  "嗜鹼性白血球異常，有可能是慢性骨隨性白血病、重金屬中毒、結核病等，請至血液科門診追蹤檢查。":"嗜鹼性白血球異常，有可能是慢性骨隨性白血病、重金屬中毒、結核病等，請至血液科門診追蹤檢查。",
  "紅血球分布寬度下降於營養缺乏之貧血，需搭配血色素，血球容積比，觀察比較，如果前述正常，則觀察即可，異常，則請至家庭醫學科門診追蹤檢查。": "紅血球分布寬度下降於營養缺乏之貧血，需搭配血色素，血球容積比，觀察比較，如果前述正常，則觀察即可，異常，則請至家庭醫學科門診追蹤檢查。",
  "紅血球分布寬度上升於營養缺乏之貧血，如缺鐵性貧血、維生素B12缺乏、葉酸缺乏之貧血，而中度和重度地中海型貧血的數值也會增加；異常，則請至家庭醫學科門診追蹤檢查。": "紅血球分布寬度上升於營養缺乏之貧血，如缺鐵性貧血、維生素B12缺乏、葉酸缺乏之貧血，而中度和重度地中海型貧血的數值也會增加；異常，則請至家庭醫學科門診追蹤檢查。",
  "血小板分布寬度異常，原因可能有脾臟切除、陣發性血小板減少性紫斑、血栓性疾病、慢性顆粒性白血病等，需搭配血小板指數及其他血液常規觀察比較，異常可至血液科門診諮詢，排除血小板功能異常所引起的出血性疾病。": "血小板分布寬度異常，原因可能有脾臟切除、陣發性血小板減少性紫斑、血栓性疾病、慢性顆粒性白血病等，需搭配血小板指數及其他血液常規觀察比較，異常可至血液科門診諮詢，排除血小板功能異常所引起的出血性疾病。",
  "平均血小板容積異常，原因可能有脾臟切除、陣發性血小板減少性紫斑、血栓性疾病、慢性顆粒性白血病等，需搭配血小板指數及其他血液常規觀察比較，異常可至血液科門診諮詢，排除血小板功能異常所引起的出血性疾病。": "平均血小板容積異常，原因可能有脾臟切除、陣發性血小板減少性紫斑、血栓性疾病、慢性顆粒性白血病等，需搭配血小板指數及其他血液常規觀察比較，異常可至血液科門診諮詢，排除血小板功能異常所引起的出血性疾病。",
  "血小板容積比異常，原因可能有脾臟切除、陣發性血小板減少性紫斑、血栓性疾病、慢性顆粒性白血病等，需搭配血小板指數及其他血液常規觀察比較，異常可至血液科門診諮詢，排除血小板功能異常所引起的出血性疾病。": "血小板容積比異常，原因可能有脾臟切除、陣發性血小板減少性紫斑、血栓性疾病、慢性顆粒性白血病等，需搭配血小板指數及其他血液常規觀察比較，異常可至血液科門診諮詢，排除血小板功能異常所引起的出血性疾病。",
  "該項檢查原本並無法查出輕度 α 型海洋性貧血帶因者及最輕度的 β 型海洋性貧血帶因者。 確定診斷應進一步做 海洋性貧血基因檢查 (α & β thalassemia PCR)。": "該項檢查原本並無法查出輕度 α 型海洋性貧血帶因者及最輕度的 β 型海洋性貧血帶因者。 確定診斷應進一步做 海洋性貧血基因檢查 (α & β thalassemia PCR)。",
  "血中汞Hg異常請至家庭醫學科門診追蹤檢查": "血中汞Hg異常請至家庭醫學科門診追蹤檢查",
  "C-胜鏈胰島素(C-peptide)為評估胰臟分泌胰島素狀況的指標。如異常建議至新陳代謝科或家醫科追蹤檢查。": "C-胜鏈胰島素(C-peptide)為評估胰臟分泌胰島素狀況的指標。如異常建議至新陳代謝科或家醫科追蹤檢查。",
  "<10.0 IU/mL 測試結果呈陰性，代表身體沒有抗體/抗體不足，需要接種德國麻疹疫苗。≧10.0 IU/mL 測試結果呈陽性，代表身體已有/足夠抗體，不須接種德國麻疹疫苗。": "<10.0 IU/mL 測試結果呈陰性，代表身體沒有抗體/抗體不足，需要接種德國麻疹疫苗。≧10.0 IU/mL 測試結果呈陽性，代表身體已有/足夠抗體，不須接種德國麻疹疫苗。",
  "德國麻疹IgG陰性, 德國麻疹IgM陰性, 表示未感染過德國麻疹，而且對德國麻疹沒有免疫力，有可能被德國麻疹感染，建議施打疫苗。": "德國麻疹IgG陰性, 德國麻疹IgM陰性, 表示未感染過德國麻疹，而且對德國麻疹沒有免疫力，有可能被德國麻疹感染，建議施打疫苗。",
  "血液凝血功能異常，建議至血液科追蹤治療。": "血液凝血功能異常，建議至血液科追蹤治療。",
  "PT-INR（國際標準凝血時間比），是用來監測體內血凝狀況。一般來說健康者的INR數值約為0.85－1.15，若有異常，應至家庭醫學科或血液科做進一步檢查。": "PT-INR（國際標準凝血時間比），是用來監測體內血凝狀況。一般來說健康者的INR數值約為0.85－1.15，若有異常，應至家庭醫學科或血液科做進一步檢查。",
  "肝功能檢驗值異常，須排除藥物、脂肪肝等生活型態所致，請至肝膽腸胃科門診追蹤。\r\n": "肝功能檢驗值異常，須排除藥物、脂肪肝等生活型態所致，請至肝膽腸胃科門診追蹤。",
  "鹼性磷酸脢ALK-P偏低，可能營養不良、貧血、甲狀腺不足、慢性腎炎、維生素D過量，大多數情形都是正常偏低，觀察即可，如有不適請至肝膽腸胃科門診追蹤。": "鹼性磷酸脢ALK-P偏低，可能營養不良、貧血、甲狀腺不足、慢性腎炎、維生素D過量，大多數情形都是正常偏低，觀察即可，如有不適請至肝膽腸胃科門診追蹤。",
  "總蛋白為血清中所含蛋白總稱，其主要成分為白蛋白和球蛋白，偏低可能與過度飢餓、營養失調、消化道障礙或肝臟疾病有關，如合併其他肝炎檢查異常，請進一步會診肝膽科醫師。": "總蛋白為血清中所含蛋白總稱，其主要成分為白蛋白和球蛋白，偏低可能與過度飢餓、營養失調、消化道障礙或肝臟疾病有關，如合併其他肝炎檢查異常，請進一步會診肝膽科醫師。",
  "球蛋白GLO異常與免疫細胞反應有關,平日請注重飲食均衡及多喝水,減少熬夜生活以便改善異常狀況。如合併其他肝炎檢查異常,請進一步會診肝膽科醫師。": "球蛋白GLO異常與免疫細胞反應有關,平日請注重飲食均衡及多喝水,減少熬夜生活以便改善異常狀況。如合併其他肝炎檢查異常,請進一步會診肝膽科醫師。",
  "肝功能檢驗值異常，須排除藥物、脂肪肝等生活型態所致，請至家庭醫學科或肝膽腸胃科門診追蹤。": "肝功能檢驗值異常，須排除藥物、脂肪肝等生活型態所致，請至家庭醫學科或肝膽腸胃科門診追蹤。",
  "膽功能異常，請至家庭醫學科或肝膽腸胃科門診追蹤。": "膽功能異常，請至家庭醫學科或肝膽腸胃科門診追蹤。",
  "飯前血糖 <70，血糖偏低，請留意頭暈或暈眩等臨床症狀，並定期至家庭醫學科或新陳代謝科追蹤治療。": "飯前血糖 <70，血糖偏低，請留意頭暈或暈眩等臨床症狀，並定期至家庭醫學科或新陳代謝科追蹤治療。",
  "飯前血糖 > 100，血糖偏高，應飲食控制，同時留意心血管風險因子包括血壓、血脂肪等變化，追蹤過程若有心血管風險變化需留意不適宜從事之工作內容如輪班夜班作業等，並定期至家庭醫學科或新陳代謝科追蹤治療。": "飯前血糖 > 100，血糖偏高，應飲食控制，同時留意心血管風險因子包括血壓、血脂肪等變化，追蹤過程若有心血管風險變化需留意不適宜從事之工作內容如輪班夜班作業等，並定期至家庭醫學科或新陳代謝科追蹤治療。",
  "飯後血糖< 80，血糖偏低，請留意頭暈或暈眩等臨床症狀，並定期至新陳代謝科追蹤治療。": "飯後血糖< 80，血糖偏低，請留意頭暈或暈眩等臨床症狀，並定期至新陳代謝科追蹤治療。",
  "飯後血糖 > 140，血糖偏高，應飲食控制，並定期至新陳代謝科追蹤治療。": "飯後血糖 > 140，血糖偏高，應飲食控制，並定期至新陳代謝科追蹤治療。",
  "醣化血色素HbA1c為評估三個月的平均血糖控制狀況,如偏高請至家庭醫學科門診或新陳代謝科追蹤檢查": "醣化血色素HbA1c為評估三個月的平均血糖控制狀況,如偏高請至家庭醫學科門診或新陳代謝科追蹤檢查",
  "尿素氮BUN偏低,如有長期蛋白質攝取不足、營養不良，皆有可能會使數值偏低。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。": "尿素氮BUN偏低,如有長期蛋白質攝取不足、營養不良，皆有可能會使數值偏低。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。",
  "尿素氮BUN偏高 如有缺乏水份、攝取大量蛋白質食物、使用類固醇藥物…等因素,皆有可能會使數值偏高。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。":"尿素氮BUN偏高 如有缺乏水份、攝取大量蛋白質食物、使用類固醇藥物…等因素,皆有可能會使數值偏高。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。",
  "肌酸酐Creatine可知腎臟過濾機能的好壞，為評估腎功能的指標，是身體肌肉細胞的代謝產物,偏低可能為慢性肌肉損傷，消瘦，肌肉量減少，多尿，女性懷孕初中期...等情況,如發生異常建議至家醫科追蹤檢查。": "肌酸酐Creatine可知腎臟過濾機能的好壞，為評估腎功能的指標，是身體肌肉細胞的代謝產物,偏低可能為慢性肌肉損傷，消瘦，肌肉量減少，多尿，女性懷孕初中期...等情況,如發生異常建議至家醫科追蹤檢查。",
  "肌酸酐Creatine可知腎臟過濾機能的好壞，為評估腎功能的指標，是身體肌肉細胞的代謝產物，偏高可能為腎功能障礙，急性肌肉損傷...等情況,如發生異常建議至家醫科追蹤檢查。":"肌酸酐Creatine可知腎臟過濾機能的好壞，為評估腎功能的指標，是身體肌肉細胞的代謝產物，偏高可能為腎功能障礙，急性肌肉損傷...等情況,如發生異常建議至家醫科追蹤檢查。",
  "尿酸偏低,通常為食物或基因遺傳或是使用藥物所引起,請至家醫科追蹤檢查": "尿酸偏低,通常為食物或基因遺傳或是使用藥物所引起,請至家醫科追蹤檢查",
  "尿酸偏高平日請減少內臟食物、帶殼海鮮食物或火鍋料及湯底食物的攝取，如有手腳關節腫痛或變形者請進一步至泌尿科或腎臟科門診追蹤": "尿酸偏高平日請減少內臟食物、帶殼海鮮食物或火鍋料及湯底食物的攝取，如有手腳關節腫痛或變形者請進一步至泌尿科或腎臟科門診追蹤",
  "腎功能相關檢驗值明顯異常，請配合病史、臨床症狀至家庭醫學科或腎臟內科門診追蹤。\r\n": "腎功能相關檢驗值明顯異常，請配合病史、臨床症狀至家庭醫學科或腎臟內科門診追蹤。",
  "血脂肪檢驗值異常，建議低油、低鹽、低膽固醇食物攝取，避免蛋黃、內臟、海鮮類如蝦蟹花枝等，配合規律有效運動，同時留意心血管風險因子包括血壓、血糖等，追蹤過程若有症狀變化需留意不適宜從事之工作內容如輪班夜班等作業，並定期至家庭醫學科追蹤治療。": "血脂肪檢驗值異常，建議低油、低鹽、低膽固醇食物攝取，避免蛋黃、內臟、海鮮類如蝦蟹花枝等，配合規律有效運動，同時留意心血管風險因子包括血壓、血糖等，追蹤過程若有症狀變化需留意不適宜從事之工作內容如輪班夜班等作業，並定期至家庭醫學科追蹤治療。",
  "乳酸脫氫酵素偏低，可能是內分泌失調，過於勞累、睡眠不好、心情不好等，觀察即可，如有不適請至家庭醫學科門診追蹤檢查。": "乳酸脫氫酵素偏低，可能是內分泌失調，過於勞累、睡眠不好、心情不好等，觀察即可，如有不適請至家庭醫學科門診追蹤檢查。",
  "乳酸脫氫酵素偏高，常見的 上升情形有 心肌梗塞、肝臟疾病、激烈運動及骨骼疾病等，建議至家庭醫學科門診追蹤檢查。": "乳酸脫氫酵素偏高，常見的 上升情形有 心肌梗塞、肝臟疾病、激烈運動及骨骼疾病等，建議至家庭醫學科門診追蹤檢查。",
  "肌酸磷化酵素CPK降低則可能與服用藥物或酒精性肝病等因素有關。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。 ": "肌酸磷化酵素CPK降低則可能與服用藥物或酒精性肝病等因素有關。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。",
  "肌酸磷化酵素CPK當肌肉細胞受傷受損時,例如心肌梗塞、肌肉發炎反應、激烈運動時就會上升。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。":"肌酸磷化酵素CPK當肌肉細胞受傷受損時,例如心肌梗塞、肌肉發炎反應、激烈運動時就會上升。建議搭配臨床症狀至家庭醫學科門診追蹤檢查。",
  "同半胱胺酸異常，此檢驗數值與心血管疾病風險有相關性，請至家庭醫學科門診追蹤檢查。": "同半胱胺酸異常，此檢驗數值與心血管疾病風險有相關性，請至家庭醫學科門診追蹤檢查。",
  "高敏感度C反應蛋白異常，此檢驗值與心血管疾病風險有相關性，建議至家庭醫學科門診追蹤檢查。": "高敏感度C反應蛋白異常，此檢驗值與心血管疾病風險有相關性，建議至家庭醫學科門診追蹤檢查。",
  "此次NTproBNP 檢驗值於異常範圍 ，此數值與心臟功能異常如心肌受損等原因有關， 請配合臨床症狀如胸悶胸痛等至心臟內科或原診治門診評估。": "此次NTproBNP 檢驗值於異常範圍 ，此數值與心臟功能異常如心肌受損等原因有關， 請配合臨床症狀如胸悶胸痛等至心臟內科或原診治門診評估。",
  "澱粉酵素Amylase偏低與肝腎功能有關,建議至肝膽腸胃科門診追蹤檢查。 ": "澱粉酵素Amylase偏低與肝腎功能有關,建議至肝膽腸胃科門診追蹤檢查。 ",
  "澱粉酵素Amylase偏高表示有消化及吸收失調或胰臟發炎現象, 建議至肝膽腸胃科門診追蹤檢查。 ": "澱粉酵素Amylase偏高表示有消化及吸收失調或胰臟發炎現象, 建議至肝膽腸胃科門診追蹤檢查。 ",
  "電解質異常，宜至家庭醫學科門診追蹤檢查。": "電解質異常，宜至家庭醫學科門診追蹤檢查。",
  "類風濕性關節炎因子異常，是體內所產生的一種自體免疫抗體，75%類風濕關節炎病患的血清及關節液裡，可發現此抗體，其他一些慢性炎症也會產生，建議宜配合病史和臨床症狀至免疫風濕科門診追蹤檢查。": "類風濕性關節炎因子異常，是體內所產生的一種自體免疫抗體，75%類風濕關節炎病患的血清及關節液裡，可發現此抗體，其他一些慢性炎症也會產生，建議宜配合病史和臨床症狀至免疫風濕科門診追蹤檢查。",
  "疑似蠶豆症，請配合病史至血液科或家庭醫學科門診追蹤檢查。": "疑似蠶豆症，請配合病史至血液科或家庭醫學科門診追蹤檢查。",
  "膽功能異常，宜至家醫科門診追蹤檢查。": "膽功能異常，宜至家醫科門診追蹤檢查。",
  "解脂酵素Lipase是胰臟製造的酵素,異常請至肝膽腸胃科或家醫科追蹤檢查。": "解脂酵素Lipase是胰臟製造的酵素,異常請至肝膽腸胃科或家醫科追蹤檢查。",
  "維他命B12濃度高低會影響生理蛋白、脂肪酸的合成與造血、細胞DNA複製。長期維他命B12缺乏，除了有貧血或紅血球的病變外，還可能會發生嚴重的神經性病症如周邊神經病變、脊椎神經退化等；異常請至家庭醫學科門診追蹤檢查。": "維他命B12濃度高低會影響生理蛋白、脂肪酸的合成與造血、細胞DNA複製。長期維他命B12缺乏，除了有貧血或紅血球的病變外，還可能會發生嚴重的神經性病症如周邊神經病變、脊椎神經退化等；異常請至家庭醫學科門診追蹤檢查。",
  "葉酸來自食物、腸道細菌合成,興細胞複製有關，為身體必須的營養素之一;異常請至家庭醫學科門診追蹤檢查。": "葉酸來自食物、腸道細菌合成,興細胞複製有關，為身體必須的營養素之一;異常請至家庭醫學科門診追蹤檢查。",
  "紅血球沈降速度測定(1hr)異常，可能身體處於發炎狀態，建議至家醫科或風濕免疫科追蹤檢查。": "紅血球沈降速度測定(1hr)異常，可能身體處於發炎狀態，建議至家醫科或風濕免疫科追蹤檢查。",
  "超壞膽固醇異常，易造成血管硬化，建議至家醫科追蹤治療": "超壞膽固醇異常，易造成血管硬化，建議至家醫科追蹤治療",
  "心臟危險因子偏高，表示有可能是心臟病的高危險群，日常生活應落實，遠離香菸，健康飲食及規律運動。平時如有感到胸悶、心悸等現象，建議至家醫科追蹤治療。": "心臟危險因子偏高，表示有可能是心臟病的高危險群，日常生活應落實，遠離香菸，健康飲食及規律運動。平時如有感到胸悶、心悸等現象，建議至家醫科追蹤治療。",
  "疑似腎病、心血管疾病或甲狀腺機能亢進，請至家醫科門診追蹤。": "疑似腎病、心血管疾病或甲狀腺機能亢進，請至家醫科門診追蹤。",
  "餐後一小時血糖濃度, 可幫助預測(糖耐受性正常)成年人以後的糖尿病患病風險。": "餐後一小時血糖濃度, 可幫助預測(糖耐受性正常)成年人以後的糖尿病患病風險。",
  "飯後一小時血糖濃度, 可幫助預測(糖耐受性正常)成年人以後的糖尿病患病風險。飯後血糖 > 140，血糖偏高，應飲食控制，並定期至新陳代謝科追蹤治療。糖尿病患者若已接受規律治療，則請主治醫師參考該數值。": "飯後一小時血糖濃度, 可幫助預測(糖耐受性正常)成年人以後的糖尿病患病風險。飯後血糖 > 140，血糖偏高，應飲食控制，並定期至新陳代謝科追蹤治療。糖尿病患者若已接受規律治療，則請主治醫師參考該數值。",
  "PHI越高，罹患攝護腺癌的風險越高，PHI數值也與侵略性攝護腺癌(癌症惡化程度Gleason≧score7)高度正相關。若PHI結果低，配合其他臨床表徵顯示罹癌風險低，醫師會建議此時不要進行切片，而是更頻繁的監控即可;若PHI結果高,醫師考量其他風險因子，會建議執行攝護腺切片或是進行其他檢測。":"PHI越高，罹患攝護腺癌的風險越高，PHI數值也與侵略性攝護腺癌(癌症惡化程度Gleason≧score7)高度正相關。若PHI結果低，配合其他臨床表徵顯示罹癌風險低，醫師會建議此時不要進行切片，而是更頻繁的監控即可;若PHI結果高,醫師考量其他風險因子，會建議執行攝護腺切片或是進行其他檢測。",
  "B型肝炎表面抗原呈陽性反應，疑B型肝炎帶原，建議每6個月至肝膽腸胃科追蹤肝功能和腹部超音波等肝炎追蹤檢查。": "B型肝炎表面抗原呈陽性反應，疑B型肝炎帶原，建議每6個月至肝膽腸胃科追蹤肝功能和腹部超音波等肝炎追蹤檢查。",
  "HBsAb 陰性：代表不曾感染B肝病毒；或雖打過疫苗但並沒有產生抗體（少數人）；有可能受B肝感染，因此會建議施打B肝疫苗。": "HBsAb 陰性：代表不曾感染B肝病毒；或雖打過疫苗但並沒有產生抗體（少數人）；有可能受B肝感染，因此會建議施打B肝疫苗。",
  "B肝e抗原陽性:感染B型肝炎病毒後，具高活動力及傳染力的階段，建議至肝膽腸胃科門診追蹤評估。":"B肝e抗原陽性:感染B型肝炎病毒後，具高活動力及傳染力的階段，建議至肝膽腸胃科門診追蹤評估。",
  "B型肝炎e抗體HBeAb為急性B型肝炎復原及治療效果的參考指標。":"B型肝炎e抗體HBeAb為急性B型肝炎復原及治療效果的參考指標。",
  "B型肝炎核心抗體(Anti-HBc)呈陽性反應，表示曾經感染或B型肝炎曝露之病史，請配合病史至肝膽腸胃科評估。":"B型肝炎核心抗體(Anti-HBc)呈陽性反應，表示曾經感染或B型肝炎曝露之病史，請配合病史至肝膽腸胃科評估。",
  "C型肝炎檢驗異常，疑慢性C型肝炎帶原或曝露，宜至肝膽腸胃科門診追蹤。": "C型肝炎檢驗異常，疑慢性C型肝炎帶原或曝露，宜至肝膽腸胃科門診追蹤。",
  "A型肝炎IgG(HAV-IgG)陰性，A型肝炎IgM(HAV-M)陰性，表示未感染過A型肝炎病毒，而且對A型肝炎病毒沒有免疫力，有可能被A型肝炎病毒感染,建議施打疫苗(自費) 。": "A型肝炎IgG(HAV-IgG)陰性，A型肝炎IgM(HAV-M)陰性，表示未感染過A型肝炎病毒，而且對A型肝炎病毒沒有免疫力，有可能被A型肝炎病毒感染,建議施打疫苗(自費) 。",
  "A型肝炎(IgM)檢驗異常，疑似感染A型肝炎，請至腸胃肝膽科門診追蹤治療。":"A型肝炎(IgM)檢驗異常，疑似感染A型肝炎，請至腸胃肝膽科門診追蹤治療。",
  "本次胃幽門桿菌檢查異常，疑曾有胃幽門桿菌之曝露或感染，請配合臨床症狀(例如上腹痛等)，病史或家族史(例如胃潰瘍病史或胃癌家族史等)至肝膽腸胃科評估並視需要治療。":"本次胃幽門桿菌檢查異常，疑曾有胃幽門桿菌之曝露或感染，請配合臨床症狀(例如上腹痛等)，病史或家族史(例如胃潰瘍病史或胃癌家族史等)至肝膽腸胃科評估並視需要治療。",
  "AFP常用於篩檢肝癌，若AFP數值偏高時，除了肝癌也可能為肝炎、胃癌、胰臟癌、肺癌或懷孕期的婦女，必須配合臨床症狀做診斷，建議至肝膽腸胃醫學科門診追蹤檢查。":"AFP常用於篩檢肝癌，若AFP數值偏高時，除了肝癌也可能為肝炎、胃癌、胰臟癌、肺癌或懷孕期的婦女，必須配合臨床症狀做診斷，建議至肝膽腸胃醫學科門診追蹤檢查。",
  "大腸癌胚抗原CEA異常,大腸癌、肺癌、腸胃道等其他部位惡性腫瘤會使CEA的指數升高，另抽菸亦使CEA昇高，若抽菸者CEA檢驗值為5以下是可接受範圍；異常請至腸胃內科門診追蹤檢查。":"大腸癌胚抗原CEA異常,大腸癌、肺癌、腸胃道等其他部位惡性腫瘤會使CEA的指數升高，另抽菸亦使CEA昇高，若抽菸者CEA檢驗值為5以下是可接受範圍；異常請至腸胃內科門診追蹤檢查。",
  "CA199 偏高，胰臟、膽道和腸胃疾病包括胰臟腫瘤等疾病均可能會使CA-19-9升高，請至家庭醫學科或腸胃內科門診追蹤檢查。":"CA199 偏高，胰臟、膽道和腸胃疾病包括胰臟腫瘤等疾病均可能會使CA-19-9升高，請至家庭醫學科或腸胃內科門診追蹤檢查。",
  "攝護腺特異抗原( PSA ) 指數偏高，良性攝護腺肥大與攝護腺癌可能會使PSA升高，請至泌尿科門診追蹤。":"攝護腺特異抗原( PSA ) 指數偏高，良性攝護腺肥大與攝護腺癌可能會使PSA升高，請至泌尿科門診追蹤。",
  "腫瘤標記檢查CA-125 偏高，卵巢、輸卵管等一些婦科腫瘤性或良性疾病與此數值相關，請至婦產科門診追蹤評估。":"腫瘤標記檢查CA-125 偏高，卵巢、輸卵管等一些婦科腫瘤性或良性疾病與此數值相關，請至婦產科門診追蹤評估。",
  "腫瘤標記檢查CA-153 偏低，乳房疾病包括乳癌或等可能使CA-153升高，請至乳房外科門診追蹤評估 。": "腫瘤標記檢查CA-153 偏低，乳房疾病包括乳癌或等可能使CA-153升高，請至乳房外科門診追蹤評估 。",
  "腫瘤標記檢查CA-153 偏高，乳房疾病包括乳癌或等可能使CA-153升高，請至乳房外科門診追蹤評估 。": "腫瘤標記檢查CA-153 偏高，乳房疾病包括乳癌或等可能使CA-153升高，請至乳房外科門診追蹤評估 。",
  "EBV異常，耳鼻喉疾病包括鼻咽癌風險和本數值相關，請至耳鼻喉科門診追蹤評估。": "EBV異常，耳鼻喉疾病包括鼻咽癌風險和本數值相關，請至耳鼻喉科門診追蹤評估。",
  "B - HCG偏低，請至婦產科門診追蹤檢查。": "B - HCG偏低，請至婦產科門診追蹤檢查。",
  "B - HCG偏高，請至婦產科門診追蹤檢查。": "B - HCG偏高，請至婦產科門診追蹤檢查。",
  "小細胞肺癌篩檢NSE偏高,NSE為小細胞肺癌及神經母細胞瘤之篩檢參考指標。對小細胞肺癌依其腫瘤分期有40%~90%不等之敏感度，神經內分泌腫瘤以及小細胞肺癌患者血清的NSE濃度會有上升，因此需由胸腔科醫師進一步診斷。":"小細胞肺癌篩檢NSE偏高,NSE為小細胞肺癌及神經母細胞瘤之篩檢參考指標。對小細胞肺癌依其腫瘤分期有40%~90%不等之敏感度，神經內分泌腫瘤以及小細胞肺癌患者血清的NSE濃度會有上升，因此需由胸腔科醫師進一步診斷。",
  "CA72-4偏高，請至家庭醫學科或腸胃內科門診追蹤檢查。":"CA72-4偏高，請至家庭醫學科或腸胃內科門診追蹤檢查。",
  "此次β2-M微小球蛋白檢驗值異常，此數值變化與淋巴、自體免疫、風濕關節或腎臟等疾病相關， 請配合病史和臨床症狀至原診治門診或家庭醫學科評估。": "此次β2-M微小球蛋白檢驗值異常，此數值變化與淋巴、自體免疫、風濕關節或腎臟等疾病相關， 請配合病史和臨床症狀至原診治門診或家庭醫學科評估。",
  "鱗狀細胞癌抗原SCC偏高不代表一定罹患癌症,可能是肺部良性疾病,少數人可能是有肺癌、子宮頸癌、鼻咽癌發生,為確保健康請提高警覺，請至胸腔科或血液腫瘤科確診原因。":"鱗狀細胞癌抗原SCC偏高不代表一定罹患癌症,可能是肺部良性疾病,少數人可能是有肺癌、子宮頸癌、鼻咽癌發生,為確保健康請提高警覺，請至胸腔科或血液腫瘤科確診原因。",
  "非小細胞癌Cyfra 21-1偏高多數是有肺部或支氣管或食道發炎，少數人是非小細胞肺癌、食道癌、鼻咽癌、乳癌、卵巢癌發生，建議進一步至家庭醫學科確診原因。": "非小細胞癌Cyfra 21-1偏高多數是有肺部或支氣管或食道發炎，少數人是非小細胞肺癌、食道癌、鼻咽癌、乳癌、卵巢癌發生，建議進一步至家庭醫學科確診原因。",
  "腫瘤多胜脢抗原（TPA)此次檢驗數值異常，若有頻尿、排尿疼痛、尿急及血尿等情形，請至內科或泌尿科門診複檢，確認病症。": "腫瘤多胜脢抗原（TPA)此次檢驗數值異常，若有頻尿、排尿疼痛、尿急及血尿等情形，請至內科或泌尿科門診複檢，確認病症。",
  "甲狀腺功能異常，宜至家庭醫學科門診追蹤檢查。": "甲狀腺功能異常，宜至家庭醫學科門診追蹤檢查。",
  "如為女性，應由婦科醫師配合年齡，婦科病史，生理期狀態和臨床症狀予以綜合評估。如為男性，應由泌尿科醫師配合年齡，病史和臨床症狀予以綜合評估。": "如為女性，應由婦科醫師配合年齡，婦科病史，生理期狀態和臨床症狀予以綜合評估。如為男性，應由泌尿科醫師配合年齡，病史和臨床症狀予以綜合評估。",
  "此次免疫球蛋白E(IgE)檢驗數值異常，此數據與過敏體質和免疫疾病相關，請配合臨床症狀、過敏免疫疾病史視需要至原診治門診或家庭醫學科評估。": "此次免疫球蛋白E(IgE)檢驗數值異常，此數據與過敏體質和免疫疾病相關，請配合臨床症狀、過敏免疫疾病史視需要至原診治門診或家庭醫學科評估。",
  "身體對胰島素出現「輕微阻抗」反應，正常的胰島素量沒辦法有效的控制血糖。身體為補償這樣的現象，就會分泌更多的胰島素來協助穩定血糖，請諮詢新陳代謝科或家醫科醫師。":"身體對胰島素出現「輕微阻抗」反應，正常的胰島素量沒辦法有效的控制血糖。身體為補償這樣的現象，就會分泌更多的胰島素來協助穩定血糖，請諮詢新陳代謝科或家醫科醫師。",
  "自體免疫ANA異常，請至家庭醫學科門診追蹤檢查。": "自體免疫ANA異常，請至家庭醫學科門診追蹤檢查。",
  "本次梅毒檢驗結果異常，需排除偽陽性之可能性，建議以高特異性檢驗複檢(例如TPHA)，請至家庭醫學科或感染科追蹤檢查。":"本次梅毒檢驗結果異常，需排除偽陽性之可能性，建議以高特異性檢驗複檢(例如TPHA)，請至家庭醫學科或感染科追蹤檢查。",
  "梅毒螺旋體試驗 (TPHA) 呈陽性反應，需排除梅毒感染之可能性，請至感染科或家庭醫學科門診追蹤治療。":"梅毒螺旋體試驗 (TPHA) 呈陽性反應，需排除梅毒感染之可能性，請至感染科或家庭醫學科門診追蹤治療。",
  "本次愛滋病毒檢驗值異常，須排除愛滋病毒感染之可能性，請至感染科追蹤治療。":"本次愛滋病毒檢驗值異常，須排除愛滋病毒感染之可能性，請至感染科追蹤治療。",
  "麻疹病毒 (Measles IgG) 抗體呈陰性，建議至家庭醫學科門診施打麻疹疫苗。": "麻疹病毒 (Measles IgG) 抗體呈陰性，建議至家庭醫學科門診施打麻疹疫苗。",
  "本次血清鐵檢驗值於異常範圍 ， 請配合血液相關病史（例如缺鐵性貧血或地中海貧血)與臨床症狀至家庭醫學科或血液科評估，於評估後視需要安排後續治療。": "本次血清鐵檢驗值於異常範圍 ， 請配合血液相關病史（例如缺鐵性貧血或地中海貧血)與臨床症狀至家庭醫學科或血液科評估，於評估後視需要安排後續治療。",
  "本次總鐵結合力TIBC檢驗值於異常範圍 ， 請配合血液相關病史（例如缺鐵性貧血或地中海貧血)與臨床症狀至家庭醫學科或血液科評估，於評估後視需要安排後續治療。": "本次總鐵結合力TIBC檢驗值於異常範圍 ， 請配合血液相關病史（例如缺鐵性貧血或地中海貧血)與臨床症狀至家庭醫學科或血液科評估，於評估後視需要安排後續治療。",
  "鐵蛋白異常，若有頭暈、身體不適，請至內科門診追蹤複檢。": "鐵蛋白異常，若有頭暈、身體不適，請至內科門診追蹤複檢。",
  "副傷寒檢測Weil-FelixOX19異常,請至家庭醫學科門診追蹤檢查": "副傷寒檢測Weil-FelixOX19異常,請至家庭醫學科門診追蹤檢查",
  "沙門桿菌H型凝集素Salmonella-H異常,請至家庭醫學科門診追蹤檢查": "沙門桿菌H型凝集素Salmonella-H異常,請至家庭醫學科門診追蹤檢查",
  "沙門桿菌O型凝集素Salmonella-O異常,請至家庭醫學科門診追蹤檢查": "沙門桿菌O型凝集素Salmonella-O異常,請至家庭醫學科門診追蹤檢查",
  "副傷寒檢測Weil-FelixOX2異常,請至家醫科門診追蹤檢查": "副傷寒檢測Weil-FelixOX2異常,請至家醫科門診追蹤檢查",
  "副傷寒檢測Weil-FelixOXK異常,請至家庭醫學科追蹤檢查 ": "副傷寒檢測Weil-FelixOXK異常,請至家庭醫學科追蹤檢查 ",
  "本次碳13檢查異常，疑胃部幽門桿菌感染，請配合臨床症狀(例如上腹痛等)，病史或家族史(例如胃潰瘍病史或胃癌家族史等)至肝膽腸胃科評估並視需要治療。":"本次碳13檢查異常，疑胃部幽門桿菌感染，請配合臨床症狀(例如上腹痛等)，病史或家族史(例如胃潰瘍病史或胃癌家族史等)至肝膽腸胃科評估並視需要治療。",
  "主要由腎上腺皮質所分泌，臨床常和ACTH搭配診斷愛迪生氏症及庫欣氏症候群，長期壓力大或晝夜顛倒的人也經常出現偏高之情形，建議至新陳代謝科追蹤檢查": "主要由腎上腺皮質所分泌，臨床常和ACTH搭配診斷愛迪生氏症及庫欣氏症候群，長期壓力大或晝夜顛倒的人也經常出現偏高之情形，建議至新陳代謝科追蹤檢查",
  "此次胰島素Insulin檢驗值於異常範圍，此數值和胰臟內分泌功能和胰島素抗性有關，請配合病史和臨床症狀至內分泌科或新陳代謝科追蹤評估。": "此次胰島素Insulin檢驗值於異常範圍，此數值和胰臟內分泌功能和胰島素抗性有關，請配合病史和臨床症狀至內分泌科或新陳代謝科追蹤評估。",
  "男性賀爾蒙異常，請至泌尿科追蹤治療":"男性賀爾蒙異常，請至泌尿科追蹤治療",
  "賀爾蒙異常，請至泌尿科追蹤治療":"賀爾蒙異常，請至泌尿科追蹤治療",
  "HLA-B27抗原陽性與僵直性脊椎炎(Ankylosing Spondylitis)及類風濕性關節炎具有強烈的相關性，異常請至風濕免疫科追蹤檢查。":"HLA-B27抗原陽性與僵直性脊椎炎(Ankylosing Spondylitis)及類風濕性關節炎具有強烈的相關性，異常請至風濕免疫科追蹤檢查。",
  "此檢驗值與骨質生成、免疫、副甲狀腺等新陳代謝疾病有相關性，請配合病史於家庭醫學定期評估。": "此檢驗值與骨質生成、免疫、副甲狀腺等新陳代謝疾病有相關性，請配合病史於家庭醫學定期評估。",
  "ASMA異常，表示可能有自體免疫性疾病，建議至免疫風濕科門診追蹤檢查。": "ASMA異常，表示可能有自體免疫性疾病，建議至免疫風濕科門診追蹤檢查。",
  "本次ANTI-TPO檢測值異常，此數值與自體免疫甲狀腺有相關， 請配合臨床症狀和病史至新陳代謝科或內分泌科追蹤評估。": "本次ANTI-TPO檢測值異常，此數值與自體免疫甲狀腺有相關， 請配合臨床症狀和病史至新陳代謝科或內分泌科追蹤評估。",
  "甲狀腺球蛋白抗體(Anti-TG)檢測值異常，此數值與自體免疫甲狀腺有相關， 請配合臨床症狀和病史至新陳代謝科或內分泌科追蹤評估。": "甲狀腺球蛋白抗體(Anti-TG)檢測值異常，此數值與自體免疫甲狀腺有相關， 請配合臨床症狀和病史至新陳代謝科或內分泌科追蹤評估。",
  "核抗體Anti-ENA SS-A(RO)異常，表示可能有自體免疫性疾病，建議至免疫風濕科門診追蹤檢查。": "核抗體Anti-ENA SS-A(RO)異常，表示可能有自體免疫性疾病，建議至免疫風濕科門診追蹤檢查。",
  "紅血球沈降速度測定(2hr)異常，可能身體處於發炎狀態，建議至血液科或風濕免疫科追蹤檢查。": "紅血球沈降速度測定(2hr)異常，可能身體處於發炎狀態，建議至血液科或風濕免疫科追蹤檢查。",
  "由腎上腺皮質分泌，主要用於腎臟對於水分及離子的再吸收，以維持血壓穩定，臨床上用於診斷原發性高醛固酮血症，當醛固酮升高時，建議至新陳代謝科追蹤檢查": "由腎上腺皮質分泌，主要用於腎臟對於水分及離子的再吸收，以維持血壓穩定，臨床上用於診斷原發性高醛固酮血症，當醛固酮升高時，建議至新陳代謝科追蹤檢查",
  "主要由腦下腺垂體合成，刺激腎上腺皮質產生cortisol，ACTH上升可能是腦下腺瘤或是腎上腺分泌不足所造成，反之可能是腦下腺功能低下，建議至新陳代謝科追蹤檢查": "主要由腦下腺垂體合成，刺激腎上腺皮質產生cortisol，ACTH上升可能是腦下腺瘤或是腎上腺分泌不足所造成，反之可能是腦下腺功能低下，建議至新陳代謝科追蹤檢查",
  "AMA異常，表示可能有自體免疫性疾病，建議至免疫風濕科門診追蹤檢查。": "AMA異常，表示可能有自體免疫性疾病，建議至免疫風濕科門診追蹤檢查。",
  "此次甲狀腺促進素結合體抗體Ab-TSH receptor檢驗值異常，請配合免疫病史和臨床症狀至新陳代謝科或內分泌科評估。": "此次甲狀腺促進素結合體抗體Ab-TSH receptor檢驗值異常，請配合免疫病史和臨床症狀至新陳代謝科或內分泌科評估。",
  "傷寒(Widal Typhoid O)異常,請至家庭醫學科門診追蹤檢查": "傷寒(Widal Typhoid O)異常,請至家庭醫學科門診追蹤檢查",
  "傷寒(Widal Typhoid H)異常,請至家庭醫學科門診追蹤檢查": "傷寒(Widal Typhoid H)異常,請至家庭醫學科門診追蹤檢查",
  "傷寒(Widal Typhoid A)異常,請至家庭醫學科門診追蹤檢查": "傷寒(Widal Typhoid A)異常,請至家庭醫學科門診追蹤檢查",
  "傷寒(Widal Typhoid B)異常,請至家庭醫學科門診追蹤檢查": "傷寒(Widal Typhoid B)異常,請至家庭醫學科門診追蹤檢查",
  "肝癌腫瘤標記異常，建議至家醫科或肝膽腸胃科追蹤肝癌腫瘤標記異常，建議至家醫科或肝膽腸胃科追蹤": "肝癌腫瘤標記異常，建議至家醫科或肝膽腸胃科追蹤肝癌腫瘤標記異常，建議至家醫科或肝膽腸胃科追蹤",
  "肺功能檢查結果異常，宜規律運動，若有抽菸請戒菸，如有不適請至胸腔內科門診追蹤檢查。": "肺功能檢查結果異常，宜規律運動，若有抽菸請戒菸，如有不適請至胸腔內科門診追蹤檢查。",
  "肺功能檢查結果異常(為阻塞型)，宜規律運動，若有抽菸請戒菸，如有不適請至胸腔內科門診追蹤檢查。": "肺功能檢查結果異常(為阻塞型)，宜規律運動，若有抽菸請戒菸，如有不適請至胸腔內科門診追蹤檢查。",
  "超壞膽固醇異常，建議至家醫科追蹤":"超壞膽固醇異常，建議至家醫科追蹤",
  "大於2.0,指數偏高可能有亢進,焦慮,急躁現象。":"大於2.0,指數偏高可能有亢進,焦慮,急躁現象。",
  "小於0.5,指數偏低可能有憂鬱情緒低落現象。":"小於0.5,指數偏低可能有憂鬱情緒低落現象。",
  "大於50,長期處於壓力負擔之下。":"大於50,長期處於壓力負擔之下。",
  "小於20表示副交感對心臟調控度變差,注意勞累,壓力,抽菸等易造成心臟負荷變大。":"小於20表示副交感對心臟調控度變差,注意勞累,壓力,抽菸等易造成心臟負荷變大。",
  "脂血1+":"脂血1+",
  "性功能異常，請至泌尿科追蹤治療":"性功能異常，請至泌尿科追蹤治療",
  "體脂肪百分比異常，注意飲食控制，多運動。":"體脂肪百分比異常，注意飲食控制，多運動。",
  "骨質密度減少的因素包含年齡增長、女性停經、患有特定疾病或長期服用影響骨質的藥物等。可增加負重及阻力運動、確保攝取足夠鈣質、適度戶外活動，以促進維生素D生成並避免菸酒；若非疾病或用藥造成的骨質減少，建議每2-3年做骨質密度檢測。若您的檢測結果為骨質疏鬆，建議攜帶報告至骨科或新陳代謝科門診追蹤。":"骨質密度減少的因素包含年齡增長、女性停經、患有特定疾病或長期服用影響骨質的藥物等。可增加負重及阻力運動、確保攝取足夠鈣質、適度戶外活動，以促進維生素D生成並避免菸酒；若非疾病或用藥造成的骨質減少，建議每2-3年做骨質密度檢測。若您的檢測結果為骨質疏鬆，建議攜帶報告至骨科或新陳代謝科門診追蹤。",
  "本次聽力檢查異常，建議避免職業或個人噪音之曝露，若有聽力變化，請至耳鼻喉科或職業醫學科追蹤。":"本次聽力檢查異常，建議避免職業或個人噪音之曝露，若有聽力變化，請至耳鼻喉科或職業醫學科追蹤。",
  "Total PSA值落於4 - 10 ng/mL的病患，其Free / Total PSA Ratio若大於0.25，則攝護腺良性機率較高。":"Total PSA值落於4 - 10 ng/mL的病患，其Free / Total PSA Ratio若大於0.25，則攝護腺良性機率較高。",
  "人類乳突病毒檢查異常，請至婦產科門診追蹤評估。":"人類乳突病毒檢查異常，請至婦產科門診追蹤評估。",
  // arr02(Ref)
  "-1.0＞T值＞-2.5：低骨密；-2.5≧T值：骨質疏鬆；-2.0≧Z值：低於同齡的預期值；-2.0＜Z值：介於同齡的預期值":"-1.0＞T值＞-2.5：低骨密；-2.5≧T值：骨質疏鬆；-2.0≧Z值：低於同齡的預期值；-2.0＜Z值：介於同齡的預期值",
  "1. 停經後女性（未接受賀爾蒙治療）pg/mL（95th Percentile Limit）：≦25.1 pg/mL 2. 非懷孕女性：卵泡早期：22.4～115.0 pg/mL；卵泡中期：25.0～115.0 pg/mL；黃體中期：36.5～246.0 pg/mL；排卵峰：32.1～517.0 pg/mL 3. 青春期（95% CI）：女性（12至<19 歲）：162.0～230.0 pg/mL；男性（12至<19 歲）：30.8～38.7 pg/mL":"1. 停經後女性（未接受賀爾蒙治療）pg/mL（95th Percentile Limit）：≦25.1 pg/mL\n 2. 非懷孕女性：卵泡早期：22.4～115.0 pg/mL；卵泡中期：25.0～115.0 pg/mL；黃體中期：36.5～246.0 pg/mL；排卵峰：32.1～517.0 pg/mL\n 3. 青春期（95% CI）：女性（12至<19 歲）：162.0～230.0 pg/mL；男性（12至<19 歲）：30.8～38.7 pg/mL",
  // arr04(Ref)
  "濾泡期:3.85-8.78; 排卵:4.54-22.51; 黃體期:1.79-5.12 mIU/mL; 更年期:16.74-113.59 mIU/mL":"濾泡期:3.85-8.78; 排卵:4.54-22.51; 黃體期:1.79-5.12 mIU/mL; 更年期:16.74-113.59 mIU/mL",
  "濾泡期:2.12-10.89; 排卵期:19.18-103.03; 黃體期:1.20-12.86; 停經後:10.87-58.64 mIU/mL":"濾泡期:2.12-10.89; 排卵期:19.18-103.03; 黃體期:1.20-12.86; 停經後:10.87-58.64 mIU/mL",
  "濾泡期:27-122; 排卵期:95-433; 黃體期:49-291; 停經後:<40 pg/mL":"濾泡期:27-122; 排卵期:95-433; 黃體期:49-291; 停經後:<40 pg/mL",
  "停經前(<50歲)3.34-26.72; 停經後(>50歲):2.74-19.64 ng/mL":"停經前(<50歲)3.34-26.72; 停經後(>50歲):2.74-19.64 ng/mL",
  "濾泡期:0.31-1.52; 黃體期:5.16-18.56; 停經:<0.08-0.78 ng/mL; 懷孕婦女 前三個月:4.73-50.74; 三至六個月:19.41-45.30 ng/mL":"濾泡期:0.31-1.52; 黃體期:5.16-18.56; 停經:<0.08-0.78 ng/mL; 懷孕婦女 前三個月:4.73-50.74; 三至六個月:19.41-45.30 ng/mL",
  "男性(20-50歲):13.3-89.5":"男性(20-50歲):13.3-89.5",
  
  
  // arr04
  "六十歲以下:3.5-5.2 g/dL，六十歲以上:3.2-4.6 g/dL":"六十歲以下:3.5-5.2 g/dL，六十歲以上:3.2-4.6 g/dL",
  // arr05
  "Level 1：心血管狀況良好":"Level 1：心血管狀況良好",
  "Level 2：心血管功能下降，循環能力下降，可能有手腳冰冷，肩頸痠麻現象":"Level 2：心血管功能下降，循環能力下降，可能有手腳冰冷，肩頸痠麻現象",
  "Level 3：心血管功能明顯下滑，循環跟代謝能力不足，可能有手腳冰冷，頭痛，肩頸四肢僵硬痠麻現象":"Level 3：心血管功能明顯下滑，循環跟代謝能力不足，可能有手腳冰冷，頭痛，肩頸四肢僵硬痠麻現象",
  "Level 4：心血管功能低弱，循環跟代謝功能較差，可能有手腳冰冷，頭痛，肩頸四肢僵硬痠麻現象":"Level 4：心血管功能低弱，循環跟代謝功能較差，可能有手腳冰冷，頭痛，肩頸四肢僵硬痠麻現象",
  "Level 5：心血管功能更顯低弱，循環跟代謝功能差，可能有手腳冰冷，頭痛，肩頸四肢僵硬痠麻現象":"Level 5：心血管功能更顯低弱，循環跟代謝功能差，可能有手腳冰冷，頭痛，肩頸四肢僵硬痠麻現象",
  "Level 6：心血管疾病高危險群，罹患心血管疾病，腦血栓，腎臟病變機率增高":"Level 6：心血管疾病高危險群，罹患心血管疾病，腦血栓，腎臟病變機率增高",
  "Level 7：心血管疾病高危險群，罹患心血管疾病，腦血栓，腎臟病變機率大幅攀升/如附件":"Level 7：心血管疾病高危險群，罹患心血管疾病，腦血栓，腎臟病變機率大幅攀升/如附件",
  // arr06
   "<70%可能為阻塞型肺疾病":"<70%可能為阻塞型肺疾病",
  // 客戶端
  "若有其他相關附件，會於健檢日前方顯示 ' > ' 符號，並可以展開（瀏覽中請按上一頁避免直接關閉）":"若有其他相關附件，會於健檢日前方顯示 ' > ' 符號，並可以展開（瀏覽中請按上一頁避免直接關閉）",
  "點擊 '(姓名)'兩下，即可下載該次 '(健檢報告)'":"點擊 '(姓名)'兩下，即可下載該次 '(健檢報告)'",

  






  
  



 






  "下載中，圖片較多請耐心等候": "下載中，圖片較多請耐心等候",
  "LINE內建之瀏覽器將無法正常下載":"LINE內建之瀏覽器將無法正常下載",
  "下載速度受網路速度影響":"下載速度受網路速度影響",
  "請用chrome或safari瀏覽器下載":"請用chrome或safari瀏覽器下載",
  "如報告下載異常，請改用非手機之瀏覽器下載":"如報告下載異常，請改用非手機之瀏覽器下載",
  "手機下載後，將會自動存放在“檔案app”內（如下圖所示）":"手機下載後，將會自動存放在“檔案app”內（如下圖所示）",





  // 'app.learn': '學習 {name}'
  // , "app.Salmon": "{name} 鮭魚"
  // , "app.loginMessage": "請輸入您的帳號、密碼"
  // , "app.screenLockMessage": "請輸入您的密碼"
  // //UserInfo
  // , "app.screenLock": "螢幕鎖定"
  // , "app.loginMessage_Error": "帳號或密碼錯誤"
  // , "app.PasswordNotMatch": "新密碼不一致"
  // , "passwordOld": "舊密碼"
  // , "passwordNew": "新密碼"
  // , "passwordConfirm": "新密碼確認"
  // , "app.changePw": "變更密碼"
  "app.LoginButton": "登 錄"
  , "UserName": "姓名"
  , "birthDate": "出生日期"
  , "personalId": "身分證字號"
  , "app.Clear": "清除"
  , "請填寫這個欄位。": "請填寫這個欄位。"
  , "請符合要求的格式。": "請符合要求的格式。"
  , "app.LoginCantFound": "抱歉,查無您的健檢紀錄\r\n請致電 04-2255-2555 #168 健檢諮詢"
  , "app.AllQuestsDone": "您所需要填寫的問卷均已提交，謝謝"
  , "app.FillNextTime": "下次填寫"
  , "app.Logout": "登出"
  , "app.Next": "下一份"
  , "app.Back": "上一份"
  , "app.Done": "完成"
  , "app.QuestsNotYet": "當前問卷尚未完成，請先提交當前問卷"
  , "app.ThankWords": "感謝您的耐心填寫"
  , "app.ThankDone": "全部已完成"
  , "app.Submit": "提 交"
  , "app.Cancel": "關閉"
  , "尚有問題未完成": "尚有問題未完成"
  , "填寫此欄位": "填寫此欄位"
  , "選擇其中一個選項": "選擇其中一個選項"
  , "勾選此註記框": "勾選此註記框"
  , "輸入數字": "輸入數字"
  , "app.pleaseSelect": "請選擇..."

  //問卷所寫
  , "心血管": "心血管"
  , "肌肉骨骼": "肌肉骨骼"
  , "心情量表": "心情量表"
  , "過勞評估": "過勞評估"
  , "勞檢問卷": "勞檢問卷"
  , "無紙化": "無紙化"
  //70
  , "十年心血管風險評估": "十年心血管風險評估"
  , "填寫前說明": "填寫前說明"
  // , "基本資料": "基本資料"
  , "體檢後": "體檢後"
  , "你有沒有吸煙": "你有沒有吸煙"
  , "你有沒有服用高血壓藥物": "你有沒有服用高血壓藥物"
  , "你有沒有糖尿病史": "你有沒有糖尿病史"
  , "沒有": "沒有"
  , "有吸煙": "有吸煙"
  , "有服用高血壓藥物": "有服用高血壓藥物"
  , "有糖尿病史": "有糖尿病史"
  , "說明：本測驗不適用於已被診斷出心血管疾病者或有接受治療者。": "說明：本測驗不適用於已被診斷出心血管疾病者或有接受治療者。"
  , "取得檢測數字[總膽固醇]-[高密度脂蛋白膽固醇]-[收縮壓]，進行風險評估試算，產生[未來10年心血管疾病風險評估表]": "取得檢測數字[總膽固醇]-[高密度脂蛋白膽固醇]-[收縮壓]，進行風險評估試算，產生[未來10年心血管疾病風險評估表]"

  //無紙化
  , "app.NopaperComfirm": "之前已確認使用無紙化服務，感謝與您一同保護地球！"
  , "app.NopaperNoexit": "查無客戶資料，請確認"
  , "健檢報告無紙化服務同意書": "健檢報告無紙化服務同意書"
  , "支持 ": "支持 "
  , "晨悅診所響應環保、節能愛地球": "晨悅診所響應環保、節能愛地球"
  , "之活動，": "之活動，"
  , "同意": "同意"
  , " 晨悅診所將本人健康檢查報告，": " 晨悅診所將本人健康檢查報告，"
  , "完成後以email方式通知至本人指定之電子信箱": "完成後以email方式通知至本人指定之電子信箱"
  , "，資料如下": "，資料如下"
  , "立書同意人：": "立書同意人："
  , "身分證字號：": "身分證字號："
  , "E-mail:   (用於通知報告完成，請您確認正確)": "E-mail:   (用於通知報告完成，請您確認正確)"
  // , "立書同意人：": "立書同意人："
  , "簽名時間：": "簽名時間："
  , "Email確認正確": "Email確認正確"
  , "點擊按鈕才算完成": "點擊按鈕才算完成"
  , "謝謝": "謝謝！請按右上角的下一份繼續"

  //sign
  , "簽名": "簽名"
  , "重新簽名": "重新簽名"
  , "確認": "確認"
  , "請簽名(行動裝置請旋轉螢幕為水平橫向)...": "請簽名(行動裝置請旋轉螢幕為水平橫向)..."
  //肌肉骨骼
  , "肌肉骨骼症狀調查表": "肌肉骨骼症狀調查表"
  , "痠痛症狀調查": "痠痛症狀調查"
  , "其他症狀、病史說明": "其他症狀、病史說明"
  , "右腳踝/右腳": "右腳踝/右腳"
  , "左腳踝/左腳": "左腳踝/左腳"
  , "右膝": "右膝"
  , "左膝": "左膝"
  , "右臀/右大腿": "右臀/右大腿"
  , "左臀/左大腿": "左臀/左大腿"
  , "右手/右手腕": "右手/右手腕"
  , "左手/左手腕": "左手/左手腕"
  , "右手肘/右前臂": "右手肘/右前臂"
  , "左手肘/左前臂": "左手肘/左前臂"
  , "右肩部": "右肩部"
  , "左肩部": "左肩部"
  , "下背部": "下背部"
  , "上背部": "上背部"
  , "頸部": "頸部"
  , "痠痛症狀調查(請對應位置，在量化後的分數欄位中點選)：0表示『不痛』;1表示『痛可忽略』;2表示『可能影響工作』;3表示『影響工作』;4表示『影響自主活動功能』;5表示『完全無法自主活動』": "痠痛症狀調查(請對應位置，在量化後的分數欄位中點選)：0表示『不痛』;1表示『痛可忽略』;2表示『可能影響工作』;3表示『影響工作』;4表示『影響自主活動功能』;5表示『完全無法自主活動』"
  , "下表的身體部位酸痛、不適或影響關節活動之情形持續多久時間？": "下表的身體部位酸痛、不適或影響關節活動之情形持續多久時間？"
  , "您平常使用電腦、滑鼠慣用手為？": "您平常使用電腦、滑鼠慣用手為？"
  , " 左手": " 左手"
  , " 右手": " 右手"
  , "是（若是，請繼續填寫下列表格。）": "是（若是，請繼續填寫下列表格。）"
  , "否（若否，結束此調查表）": "否（若否，結束此調查表）"
  , "1個月": "1個月"
  , "3個月": "3個月"
  , "6個月": "6個月"
  , "1年": "1年"
  , "3年": "3年"
  , "3年以上": "3年以上"
  , "下列任何部位請以酸痛不適與影響關節活動評斷。任選分數高者。": "下列任何部位請以酸痛不適與影響關節活動評斷。任選分數高者。"
  , "酸痛不適程度與關節活動能力：（以肩關節為例） 請在第二部分作答": "酸痛不適程度與關節活動能力：（以肩關節為例） 請在第二部分作答"
  , "不痛": "不痛"
  , "痛可忽略": "痛可忽略"
  , "可能影響工作": "可能影響工作"
  , "影響工作": "影響工作"
  , "影響自主活動功能": "影響自主活動功能"
  , "完全無法自主活動": "完全無法自主活動"
  , "您在過去的1年內，身體是否有長達2星期以上的疲勞、酸痛、發麻、刺痛等不舒服，或關節活動受到限制？": "您在過去的1年內，身體是否有長達2星期以上的疲勞、酸痛、發麻、刺痛等不舒服，或關節活動受到限制？"





  , "晨悅預防醫學": "晨悅預防醫學"
  , "健康人生，攜手晨悅": "健康人生，攜手晨悅"
  , "請選取其中一個選項。": "請選取其中一個選項。"

  //心情量表
  , "計分方式": "計分方式"
  , "沒有或極少": "沒有或極少"
  , "有時候": "有時候"
  , "時常": "時常"
  , "常常或總是": "常常或總是"
  , "我常常覺得想哭": "我常常覺得想哭"
  , "我覺得心情不好": "我覺得心情不好"
  , "我覺得比以前容易發脾氣": "我覺得比以前容易發脾氣"
  , "我睡不好": "我睡不好"
  , "我覺得不想吃東西": "我覺得不想吃東西"
  , "我覺得胸口悶悶的": "我覺得胸口悶悶的"
  , "我覺得不輕鬆、不舒服": "我覺得不輕鬆、不舒服"
  , "我覺得身體疲勞虛弱無力": "我覺得身體疲勞虛弱無力"
  , "我覺得很煩": "我覺得很煩"
  , "我覺得記憶力不好": "我覺得記憶力不好"
  , "我覺得做事時無法專心": "我覺得做事時無法專心"
  , "我覺得想事情或做事時比平常要緩慢": "我覺得想事情或做事時比平常要緩慢"
  , "我覺得比以前沒信心": "我覺得比以前沒信心"
  , "我覺得比較會往壞處想": "我覺得比較會往壞處想"
  , "我覺得想不開，甚至想死": "我覺得想不開，甚至想死"
  , "我覺得對什麼事都失去興趣": "我覺得對什麼事都失去興趣"
  , "我覺得身體不舒服": "我覺得身體不舒服"
  , "我覺得自己很沒用": "我覺得自己很沒用"
  , "『沒有或極少』0分；『有時候』1分；『時常』2分；『常常或總是』3分": "『沒有或極少』0分；『有時候』1分；『時常』2分；『常常或總是』3分"
  , "8 分以下---情緒穩定": "8 分以下---情緒穩定"
  , "9~14分---情緒較不穩定、多注意情緒變化，多給自己關心": "9~14分---情緒較不穩定、多注意情緒變化，多給自己關心"
  , "15~18分---壓力負荷已到極點，需要找朋友交談、舒緩情緒": "15~18分---壓力負荷已到極點，需要找朋友交談、舒緩情緒"
  , "19分以上---必須找專業醫療單位協助": "19分以上---必須找專業醫療單位協助"
  , "說明：本量表所列舉的問題是為協助您瞭解您的心情狀況，請您仔細回想在一星期中，這些問題發生幾天，然後圈選一個您認為最能代表您感覺的答案。『沒有或極少』1天以下/週，『有時候』1~2天/週，『時常』3~4天/週，『常常或總是』5~7天/週": "說明：本量表所列舉的問題是為協助您瞭解您的心情狀況，請您仔細回想在一星期中，這些問題發生幾天，然後圈選一個您認為最能代表您感覺的答案。『沒有或極少』1天以下/週，『有時候』1~2天/週，『時常』3~4天/週，『常常或總是』5~7天/週"

  //過勞評估量表
  , "過勞評估量表": "過勞評估量表"
  , "個人疲勞": "個人疲勞"
  , "工作疲勞": "工作疲勞"
  , "分數解釋": "分數解釋"
  , "個人相關過勞": "個人相關過勞"
  , "50 分以下": "50 分以下"
  , "輕微": "輕微"
  , "您的過負荷程度輕微，您並不常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。": "您的過負荷程度輕微，您並不常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。"
  , "50－70 分": "50－70 分"
  , "中度": "中度"
  , "你的個人過負荷程度中等。您有時候感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您找出生活的壓力源，進一步的調適自己，增加放鬆與休息的時間。": "你的個人過負荷程度中等。您有時候感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您找出生活的壓力源，進一步的調適自己，增加放鬆與休息的時間。"
  , "70 分以上": "70 分以上"
  , "嚴重": "嚴重"
  , "您的個人過負荷程度嚴重。您時常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。": "您的個人過負荷程度嚴重。您時常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。"
  , "工作相關過勞": "工作相關過勞"
  , "45 分以下": "45 分以下"
  , "您的工作相關過負荷程度輕微，您的工作並不會讓您感覺很沒力、心力交瘁、很挫折。": "您的工作相關過負荷程度輕微，您的工作並不會讓您感覺很沒力、心力交瘁、很挫折。"
  , "45－60 分": "45－60 分"
  , "您的工作相關過負荷程度中等，您有時對工作感覺沒力，沒有興趣，有點挫折。": "您的工作相關過負荷程度中等，您有時對工作感覺沒力，沒有興趣，有點挫折。"
  , "60 分以上": "60 分以上"
  , "您的工作相關過負荷程度嚴重，您已經快被工作累垮了，您感覺心力交瘁，感覺挫折，而且上班時都很難熬，此外您可能缺少休閒時間，沒有時間陪伴家人朋友。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。": "您的工作相關過負荷程度嚴重，您已經快被工作累垮了，您感覺心力交瘁，感覺挫折，而且上班時都很難熬，此外您可能缺少休閒時間，沒有時間陪伴家人朋友。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。"
  , "你常覺得疲勞嗎?": "你常覺得疲勞嗎?"
  , "你常覺得身體上體力透支嗎?": "你常覺得身體上體力透支嗎?"
  , "你常覺得情緒上心力交瘁嗎?": "你常覺得情緒上心力交瘁嗎?"
  , "你常會覺得，「我快要撐不下去了」嗎?": "你常會覺得，「我快要撐不下去了」嗎?"
  , "你常覺得精疲力竭嗎?": "你常覺得精疲力竭嗎?"
  , "你常常覺得虛弱，好像快要生病了嗎?": "你常常覺得虛弱，好像快要生病了嗎?"
  , "你的工作會令人情緒上心力交瘁嗎？": "你的工作會令人情緒上心力交瘁嗎？"
  , "你的工作會讓你覺得快要累垮了嗎?": "你的工作會讓你覺得快要累垮了嗎?"
  , "你的工作會讓你覺得挫折嗎?": "你的工作會讓你覺得挫折嗎?"
  , "工作一整天之後，你覺得精疲力竭嗎?": "工作一整天之後，你覺得精疲力竭嗎?"
  , "上班之前只要想到又要工作一整天，你就覺得沒力嗎?": "上班之前只要想到又要工作一整天，你就覺得沒力嗎?"
  , "上班時你會覺得每一刻都很難熬嗎?": "上班時你會覺得每一刻都很難熬嗎?"
  , "不工作的時候，你有足夠的精力陪朋友或家人嗎?": "不工作的時候，你有足夠的精力陪朋友或家人嗎?"
  , "總是": "總是"
  , "常常": "常常"
  , "不常": "不常"
  , "從未或幾乎從未": "從未或幾乎從未"
  , "說明：本量表所列舉的問題是為協助您瞭解您的身心適應狀況，請您仔細回想在最近一星期中(包括今天)，這些問題使您感到困擾或苦惱的程度，然後圈選一個您認為最能代表您感覺的答案。": "說明：本量表所列舉的問題是為協助您瞭解您的身心適應狀況，請您仔細回想在最近一星期中(包括今天)，這些問題使您感到困擾或苦惱的程度，然後圈選一個您認為最能代表您感覺的答案。"
  , "有一些": "有一些"
  , "很嚴重": "很嚴重"
  , "非常輕微": "非常輕微"
  //勞工體(健)檢問卷
  , "勞工體(健)檢問卷": "勞工體(健)檢問卷"
  , "一、作業經歷：": "一、作業經歷："
  , "1.曾經從事": "1.曾經從事"
  , "起始日期:": "起始日期:"
  , "截止日期:": "截止日期:"
  , "2.目前從事": "2.目前從事"
  , "3.過去 1 個月，平均每週工時為：": "3.過去 1 個月，平均每週工時為："
  , "小時": "小時"
  , "；過去 6 個月，平均每週工時為：": "；過去 6 個月，平均每週工時為："
  , "新進員工": "新進員工"
  , "定期檢查": "定期檢查"
  , "二、檢查時期（原因）：": "二、檢查時期（原因）："
  , "三、既往病史：": "三、既往病史："
  , "您是否曾患有下列慢性疾病：（請在適當項目前打勾）": "您是否曾患有下列慢性疾病：（請在適當項目前打勾）"
  , "以上皆無": "以上皆無"
  , "無明顯異常": "無明顯異常"
  , "平均每天睡眠時間為：1小時。": "平均每天睡眠時間為：1小時。"
  , "平均每天睡眠時間為：2小時。": "平均每天睡眠時間為：2小時。"
  , "平均每天睡眠時間為：3小時。": "平均每天睡眠時間為：3小時。"
  , "平均每天睡眠時間為：4小時。": "平均每天睡眠時間為：4小時。"
  , "平均每天睡眠時間為：5小時。": "平均每天睡眠時間為：5小時。"
  , "平均每天睡眠時間為：6小時。": "平均每天睡眠時間為：6小時。"
  , "平均每天睡眠時間為：7小時。": "平均每天睡眠時間為：7小時。"
  , "平均每天睡眠時間為：8小時。": "平均每天睡眠時間為：8小時。"
  , "平均每天睡眠時間為：9小時。": "平均每天睡眠時間為：9小時。"
  , "平均每天睡眠時間為：10小時。": "平均每天睡眠時間為：10小時。"
  , "平均每天睡眠時間為：11小時。": "平均每天睡眠時間為：11小時。"
  , "平均每天睡眠時間為：12小時。": "平均每天睡眠時間為：12小時。"
  , "從未吸菸、從未嚼食檳榔、從未喝酒。": "從未吸菸、從未嚼食檳榔、從未喝酒。"
  ,"偶爾吸(不是天天)、從未嚼食檳榔、偶爾喝(不是天天)。":"偶爾吸(不是天天)、從未嚼食檳榔、偶爾喝(不是天天)。"
  ,"從未吸菸、從未嚼食檳榔、偶爾喝(不是天天)。":"從未吸菸、從未嚼食檳榔、偶爾喝(不是天天)。"
  , "正常": "正常"
  , "無": "無"
  , "骨折": "骨折"
  , "其他慢性病": "其他慢性病"
  , "手術開刀": "手術開刀"
  , "癌症": "癌症"
  , "逆流性食道炎": "逆流性食道炎"
  , "消化性潰瘍、胃炎": "消化性潰瘍、胃炎"
  , "甲狀腺疾病": "甲狀腺疾病"
  , "聽力障礙": "聽力障礙"
  , "中耳炎": "中耳炎"
  , "貧血": "貧血"
  , "肝病": "肝病"
  , "腎臟病": "腎臟病"
  , "肺結核": "肺結核"
  , "慢性氣管炎、肺氣腫": "慢性氣管炎、肺氣腫"
  , "氣喘": "氣喘"
  , "癲癇": "癲癇"
  , "中風": "中風"
  , "白內障": "白內障"
  , "心臟病": "心臟病"
  , "糖尿病": "糖尿病"
  , "高血壓": "高血壓"
  , "四、生活習慣：": "四、生活習慣："
  , "1.請問您過去一個月內是否有吸菸？": "1.請問您過去一個月內是否有吸菸？"
  , "從未吸菸": "從未吸菸"
  , "偶爾吸(不是天天)": "偶爾吸(不是天天)"
  , "幾乎)每天吸": "幾乎)每天吸"
  , "已經戒菸，戒了": "已經戒菸，戒了"
  , "平均每天吸": "平均每天吸"
  , "支": "支"
  , "已吸菸": "已吸菸"
  , "2.請問您最近六個月內是否有嚼食檳榔？": "2.請問您最近六個月內是否有嚼食檳榔？"
  , "從未嚼食檳榔": "從未嚼食檳榔"
  , "偶爾嚼(不是天天)": "偶爾嚼(不是天天)"
  , "(幾乎)每天嚼": "(幾乎)每天嚼"
  , "已經戒食，戒了": "已經戒食，戒了"
  , "平均每天嚼": "平均每天嚼"
  , "已嚼 ": "已嚼 "
  , "3.請問您過去一個月內是否有喝酒？": "3.請問您過去一個月內是否有喝酒？"
  , "從未喝酒": "從未喝酒"
  , "偶爾喝(不是天天)": "偶爾喝(不是天天)"
  , "（幾乎）每天喝": "（幾乎）每天喝"
  , "已經戒酒，戒了": "已經戒酒，戒了"
  , "平均每週喝": "平均每週喝"
  , "最常喝 ": "最常喝 "
  , "酒": "酒"
  , "每次 ": "每次"
  , "瓶": "瓶"
  , "4.請問您於工作日期間，平均每天睡眠時間為：": "4.請問您於工作日期間，平均每天睡眠時間為："
  , "五、自覺症狀：": "五、自覺症狀："
  , "您最近三個月是否常有下列症狀：（請在適當項目前打勾）": "您最近三個月是否常有下列症狀：（請在適當項目前打勾）"
  , "咳嗽": "咳嗽"
  , "咳痰": "咳痰"
  , "呼吸困難": "呼吸困難"
  , "胸痛": "胸痛"
  , "心悸": "心悸"
  , "頭暈": "頭暈"
  , "頭痛": "頭痛"
  , "耳鳴": "耳鳴"
  , "倦怠": "倦怠"
  , "噁心": "噁心"
  , "腹痛": "腹痛"
  , "便秘": "便秘"
  , "腹瀉": "腹瀉"
  , "血便": "血便"
  , "上背痛": "上背痛"
  , "下背痛": "下背痛"
  , "手腳麻痛": "手腳麻痛"
  , "關節疼痛": "關節疼痛"
  , "排尿不適": "排尿不適"
  , "多尿、頻尿": "多尿、頻尿"
  , "手腳肌肉無力": "手腳肌肉無力"
  , "體重減輕 3公斤以上": "體重減輕 3公斤以上"
  , "其他症狀": "其他症狀"
  , "年": "年"
  , "個月": "個月"
  , "次": "次"
  , "顆": "顆"
  , "共": "共"

  , "update success": "更新成功"
  , "update fail": "更新失敗"
  , "如果你要繼續執行，請勾選這個核取方塊。": "如果你要繼續執行，請勾選這個核取方塊。"


  // , "app.Languages": "語言"
  // , "app.Colors": "顏色"
  // , "app.pleaseSelect": "請選擇..."
  // , "app.add": "新增"
  // , "app.addPlus": "新增+"
  // , "app.sendCheck": "送審"
  // , "app.delete": "刪除"
  // , "app.Edit": "編輯"
  // , "app.Undelete": "反刪除"
  // , "app.Audit": "審核"
  // , "app.UnAudit": "反審核"
  // , "app.Cancel": "取消"
  // , "app.Submit": "上傳"
  // , "app.isDelete": "確認是否刪除?"
  // , "app.UploadYourFile": "請上傳檔案..."
  // , "app.administrator": "管理員無法被修改"
  // , "app.haveData": "尚有明細無法刪除"
  // , "app.Query": "查詢"
  // , "app.CloseAll": "關閉所有"
  // , "app.CloseOthers": "關閉其他"

  // // helperText for Validator
  // , "noRepeat": "不可重複"
  // , "required": "必填"
  // , "minLength": "最小長度"
  // , "maxLength": "最大長度"
  // //EmployeeTable
  // , "EmployeeTable": "員工列表"
  // , "empName": "姓名"
  // , "empAddress": "地址"
  // , "pensionRate": "退休金率"
  // , "seniorityY": "年資(Y)"
  // , "seniorityM": "年資(M)"
  // , "seniorityMTotal": "總年資(M)"
  // , "empPhone": "電話"
  // , "companyId": "公司"
  // , "companyName": "公司"
  // , "empSID": "身分證號"
  // , "empAccount": "帳號"
  // , "email": "email"
  // , "gender": "性別"
  // , "genderText": "性別"
  // , "dateBirth": "生日"
  // , "dateQuit": "離職日"
  // , "dateHire": "僱用日"
  // , "dateCreate": "資料創建日"
  // , "EmployeeWageStructureTable": "員工薪資結構表"
  // , "WageAmount": "金額"
  // , "DataAdd": "建立時間"
  // , "ExemptClock": "需要打卡"
  // , "ExemptClockText": "需要打卡"
  // //CompanyTable
  // , "CompanyTable": "公司列表"
  // , "companyName": "公司名稱"
  // , "taxNumber": "稅號"
  // , "address": "地址"
  // , "prefixTitle": "前綴"
  // , "ZipCode": "郵編"
  // ////ShiftsTable
  // , "ShiftsTable": "班別設定"
  // , "sqShifts": "班別名稱"
  // , "shiftsName": "班別名稱"
  // , "WorkTimeStart": "上班時間"
  // , "WorkTimeEnd": "下班時間"
  // , "RestTimeStart": "休息開始"
  // , "RestTimeEnd": "休息開始"
  // , "workhours": "工時"
  // //WageTypeTable
  // , "WageTypeTable": "薪資類型表"
  // , "name": "名稱"
  // , "kind": "類型"
  // , "DateAdd": "新增日期"
  // , "currencyId": "幣別"
  // , "amount": "金額"
  // , "wageStructure": "薪資結構"
  // , "wageHistory": "歷史薪資"
  // //empInsurance
  // , "EmpInsuranceTitle": "勞健保級距列表"
  // , "subSq": "No."
  // , "salaryRank": "薪水級距"
  // , "labourInsurance": "勞保(個人)"
  // , "labourInsuranceEntity": "勞保(企業)"
  // , "healthCare": "健保(個人)"
  // , "healthCareEntity": "健保(企業)"
  // , "year": "Year"
  // , "DateFrom": "起始日"
  // , "DateTo": "結束日"
  // , "local": "區域"
  // //LeaveTypeContainer
  // , "LeaveTypeContainer": "請假類別設定"
  // , "payRatio": "支付比例"
  // //LeaveApplicationContainer
  // , "LeaveApplicationContainer": "請假類單申請"
  // , "sqLeaveType": "假別類別"
  // , "LeaveTypeName": "假別類別"
  // , "empId_applicant": "申請人"
  // , "LeaveApplicantName": "申請人"
  // , "empId_substitute": "代理人"
  // , "LeaveSubstituteName": "代理人"
  // , "dateFrom": "起始日期"
  // , "dateTo": "結束日期"
  // , "hours": "請假時數"
  // , "checkType": "簽核狀態"
  // , "CheckTypeName": "簽核狀態"
  // , "leaveDescription": "說明"
  // //LeaveApplicationCheckContainer
  // , "LeaveApplicationCheckContainer": "請假類單審核"
  // //roles
  // , "RolesSetting": "角色設定"
  // , "rolesName": "角色名稱"
  // //Attendance
  // , "AttendanceUploadTitle": "出勤上傳"
  // , "isUpload": "是否上傳"
  // , "AttendanceRecordTitle": "出勤紀錄"
  // , "everyday": "日期"
  // , "AttendanceStatus": "出勤狀況"
  // , "isWorkday": "上班日"
  // , "clockDate": "打卡日期"
  // , "startTime": "上班打卡時間"
  // , "endTime": "下班打卡時間"
  // , "manualStartTime": "手動上班時間"
  // , "manualEndTime": "手動下班時間"
  // //AttendanceAdjust
  // , "AttendanceAdjustEmpTitle": "出勤人員"
  // , "PersonalAttendanceAdjustTitle": "出勤時數"
  // , "WorkOwedHours": "積欠小時"
  // , "WorkOverTime": "加班小時"
  // , "manualWorkOwedHours": "修正請假時數"
  // , "manualWorkOverTime": "修正加班時數"
  // , "AdjustConfirm": "調整確認"
  // , "AdjustDelete": "刪除調整"
  // , "AdjustTextNotConfirm": "未確認調整"
  // , "AdjustTextConfirmed": "確認調整時間:"
  // //WageCalculatorTable
  // , "WageCalculatorTitle": "薪資計算表"
  // , "BasicAmt": "薪資"
  // , "workOverTime133": "加班時數(一皆)"
  // , "workOverTime166": "加班時數(二皆)"
  // , "overtimeExpenses": "加班費"
  // , "workOwedTime": "請假/遲到時數"
  // , "owedExpenses": "請假/遲到扣薪"
  // , "totalSalary": "總薪資"
  // , "levelRank": "投保級距"
  // , "selfSaving": "員工自提"
  // , "pensionEntity": "退休金"
  // , "actualSalary": "實付薪資"
  // , "actualSalaryWithBonus": "實付薪資(含獎金)"
  // , "manualBonus01": "獎金(一)"
  // , "manualBonus02": "獎金(二)"
  // , "manualBonus03": "獎金(三)"
  // , "setAllmanualBonus01": "設定全獎金(一)"
  // , "setAllmanualBonus02": "設定全獎金(二)"
  // , "setAllmanualBonus03": "設定全獎金(三)"
  // //JobsType
  // , "sqJobsType": "NO."
  // , "JobsTypeName": "工作性質"
  // //CalendarTable
  // , "holidayDescription": "描述"
  // , "multiplierRate": "係數"
  // , "DateRest": "日期"

  // , "UserName": "姓名"
  , "checkdate": "體檢日期"
  , "barcode": "條碼號"
  , "PersonalId": "身分證號"
  , "UpdateCount": "更新次數"
  , "app.FrozenColumn": "凍結欄位"
  , "app.ColumnCount": "欄位數"
  , "app.ShowColumn": "顯示欄位"

  //BigCalendar
  , "start": "起始時間"
  , "end": "結束時間"
  , "resourceId": "會議室"
  , "title": "會議內容"
  , "department": "部門"
  , "app.CancelBooking": "取消預約"

  //WeeklyBooking
  , "SOMEDAY": "預約日期"
  , "RANGETIME": "時段"
  , "Limit": "限額"
  , "DY": "到院"
  , "CW": "腸胃"
  , "AMQC": "AM企檢"
  , "PMQC": "PM企檢"
  , "AMGC": "AM個檢"
  , "PMGC": "PM個檢"
  , "AMBC": "AM補檢"
  , "PMBC": "PM補檢"
  , "FL": "防老"
  , "Hear": "聽力全頻"
  , "Ultra": "心超"
  , "Lung": "肺功能"
  , "Auto": "全自動"
  , "DXA": "DXA"
  , "MP": "抹片"
  , "VIP": "VIP"
  , "VIPRest": "VIP餐廳"

  //WeeklyBooking
  , "BarCodeStr": "BarCodeStr"
  , "ID": "ID"
  , "SpecNo66": "更新66"

  //80
  , "是否需要輪班?": "是否需要輪班?"
  , "Shift2": "兩班制"
  , "Shift3": "三班制"
  , "Shift4": "四班制"
  , "ShiftOther": "其他："
  , "Yes": "是"
  , "No": "否"
  , "新勞檢測試": "勞檢"

};
export default zh_TW;